import React, { useState, useEffect, useRef, useMemo } from "react";
import gsap from "gsap";

import Navbar from "./Navbar";
import { motion, AnimatePresence } from "framer-motion";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MapPin, ChevronLeft, ChevronRight, CheckCircle2 } from "lucide-react";

// import { Linkedin, Twitter, Mail } from "lucide-react";
import "react-tooltip/dist/react-tooltip.css"; // Import tooltip CSS
// import { Link } from "react-router-dom";
import { Link } from "react-router-dom";
import IndustriesSection from "./IndustriesSection";
import SlbprProjectPopup from "./SlbprPopUp";

gsap.registerPlugin(ScrollTrigger);

const faqs = [
  {
    question: "What services does your IT company offer?",
    answer:
      "We offer a comprehensive range of IT services, including network management, cloud computing, cybersecurity, it consulting services and website development companies. Our services are designed to help small & medium businesses thrive in today’s digital world.",
  },
  {
    question: "How much does it cost to develop a website or application?",
    answer:
      "The cost depends on the project complexity and requirements. Contact us for a quote.",
  },
  {
    question: "How long does it take to complete a typical project?",
    answer:
      "Project timelines vary. Small projects may take weeks, while complex ones can take months.",
  },
  {
    question: "Do you provide ongoing support and maintenance?",
    answer:
      "Yes, we offer maintenance and support packages for all our clients.",
  },
  {
    question: "What is your development process?",
    answer:
      "Our process includes consultation, design, development, testing, and deployment.",
  },
  {
    question: "Do you work with clients remotely?",
    answer:
      "Yes, we work with clients worldwide via online meetings and collaboration tools.",
  },
  {
    question: "How do you ensure the security of the applications you develop?",
    answer:
      "We follow industry best practices, encryption, and security audits.",
  },
  {
    question:
      "Can you help with an existing project or do you only work on new projects?",
    answer: "We can help with both new and existing projects.",
  },
];

const images = [
  "/images/aws.png",
  "/images/aa.png",
  "/images/bb.png",
  "/images/cc.png",
  "/images/dd.png",
  "/images/ee.png",
  "/images/ff.png",
  "/images/gg.png",
  "/images/hh.png",
  "/images/ii.png",
  "/images/jj.png",
  "/images/kk.png",
  "/images/ll.png",
  "/images/mm.png",
  "/images/nn.png",
  "/images/oo.png",
  "/images/pp.png",
];

const cards = [
  {
    icon: "🗄️",
    label: "CASE STUDY",
    title: "Data Solution for Efficient Resource Management",
    highlighted: false,
    studyIndex: 8,
  },
  {
    icon: "☁️",
    label: "CASE STUDY",
    title: "Seamless Data Migration from On-Premise to Cloud",
    highlighted: false,
    studyIndex: 9,
  },
  {
    icon: "🛡️",
    label: "CASE STUDY",
    title: "Disaster Recovery and Cybersecurity Prevention",
    highlighted: false,
    studyIndex: 10,
  },
  {
    icon: "⚙️",
    label: "CASE STUDY",
    title: "Automation Solution with Terraform IaC and Jenkins CI/CD",
    highlighted: false,
    studyIndex: 11,
  },
  {
    icon: "👥",
    label: "CASE STUDY",
    title: "Enhancing Customer Experience with DevOps",
    highlighted: false,
    studyIndex: 0,
  },
  {
    icon: "🤖",
    label: "CASE STUDY",
    title: "AI Chatbot Development for Enhanced Customer Engagement",
    highlighted: false,
    studyIndex: 7,
  },
  {
    icon: "📱",
    label: "CASE STUDY",
    title: "Android & iOS App Development with Web Solutions",
    highlighted: false,
    studyIndex: 6,
  },
  {
    icon: "📧",
    label: "CASE STUDY",
    title: "Automation of Email Scheduler & Web Solution for Promotional Campaigns",
    highlighted: false,
    studyIndex: 5,
  },
  {
    icon: "🖥️",
    label: "CASE STUDY",
    title: "Frontend & Backend Design for Seamless User Experience",
    highlighted: false,
    studyIndex: 2,
  },
  {
    icon: "🧠",
    label: "CASE STUDY",
    title: "AI-ML & ERP Solutions for Business Optimization",
    highlighted: false,
    studyIndex: 1,
  },
  {
    icon: "🚀",
    label: "CASE STUDY",
    title: "Enhancing Deployment Efficiency with DevOps",
    highlighted: false,
    studyIndex: 0,
  },
  {
    icon: "💼",
    label: "CASE STUDY",
    title: "Custom CRM Software for Enhanced Business Operations",
    highlighted: false,
    studyIndex: 3,
  },
];

// const offices = [
//   {
//     id: 1,
//     name: "Sharjah Media City (Shams), ",
//     image:
//       "https://cdn.pixabay.com/photo/2016/10/16/10/30/office-space-1744803_1280.jpg",
//     address: "Al Messaned, Al Bataeh, Sharjah, United Arab Emirates",
//     // phone: "+91 80 3456 7890",
//     // email: "contact@ITSoftlab.com",
//   },
//   {
//     id: 3,
//     name: "Dubai, UAE",
//     image:
//       "https://cdn.pixabay.com/photo/2016/10/16/10/30/office-space-1744805_640.jpg",
//     address:
//       "HDS Business Centre, 34th Cluster M, Jumeirah Lake Towers, Dubai, United Arab Emirates",
//     // phone: "+91 80 3456 7890",
//     // email: "contact@ITSoftlab.com",
//   },
//   {
//     id: 6,
//     name: "Indore, India",
//     image:
//       "https://cdn.pixabay.com/photo/2017/03/28/12/10/chairs-2181951_1280.jpg",
//     address: "651 Sector A Mahalaxmi Nagar Indore, INDIA",
//     // phone: "+91 22 1234 5678",
//     // email: "contact@ITSoftlab.com",
//   },
//   {
//     id: 2,
//     name: "Malta, Europe",
//     image:
//       "https://cdn.pixabay.com/photo/2015/05/29/19/17/study-789631_640.jpg",
//     address: "Tower Business Centre, Tower Street, Swatar, BKR 4013, MALTA",
//     // phone: "+91 80 3456 7890",
//     // email: "contact@ITSoftlab.com",
//   },
//   {
//     id: 5,
//     name: "Jaipur, India",
//     image:
//       "https://cdn.pixabay.com/photo/2017/03/28/12/09/chairs-2181939_1280.jpg",
//     address: "6, Khandelwal Tower, Vidhyadhar Nagar Jaipur, INDIA",
//     // phone: "+91 11 2345 6789",
//     // email: "contact@ITSoftlab.com",
//   },

//   {
//     id: 4,
//     name: "Texas, US",
//     image:
//       "https://cdn.pixabay.com/photo/2023/04/18/17/14/ai-generated-7935610_640.jpg",
//     address: "1220 River Bend Dr, Dallas, TX, 75247, USA",
//     // phone: "+91 80 3456 7890",
//     // email: "contact@ITSoftlab.com",
//   },

// ];

const officeLocations = [
  // {
  //   id: "sharjah",
  //   city: "Sharjah Media City",
  //   region: "United Arab Emirates",
  //   address: "Al Messaned, Al Bataeh, Sharjah, United Arab Emirates",
  //   imageUrl: "https://cdn.pixabay.com/photo/2016/10/16/10/30/office-space-1744803_1280.jpg",
  //   color: "hsl(198, 90%, 55%)",
  // },
  // {
  //   id: "dubai",
  //   city: "Dubai",
  //   region: "United Arab Emirates",
  //   address: "HDS Business Centre, 34th Cluster M, Jumeirah Lake Towers, Dubai, United Arab Emirates",
  //   imageUrl: "https://cdn.pixabay.com/photo/2016/10/16/10/30/office-space-1744805_640.jpg",
  //   color: "hsl(356, 75%, 53%)",
  // },
  {
    id: "indore",
    city: "Indore",
    region: "Madhya Pradesh",
    address: "651 Sector A Mahalaxmi Nagar Indore,Madhya pradesh, INDIA",
    imageUrl:
      "https://cdn.pixabay.com/photo/2017/03/28/12/10/chairs-2181951_1280.jpg",
    color: "hsl(122, 39%, 49%)",
  },
  {
    id: "jaipur",
    city: "Jaipur",
    region: "Rajasthan",
    address: "6, Khandelwal Tower, Vidhyadhar Nagar Jaipur,Rajasthan, INDIA",
    imageUrl:
      "https://cdn.pixabay.com/photo/2017/03/28/12/09/chairs-2181939_1280.jpg",
    color: "hsl(27, 87%, 60%)",
  },
  // {
  //   id: "malta",
  //   city: "Malta",
  //   region: "Europe",
  //   address: "Tower Business Centre, Tower Street, Swatar, BKR 4013, MALTA",
  //   imageUrl: "https://cdn.pixabay.com/photo/2015/05/29/19/17/study-789631_640.jpg",
  //   color: "hsl(266, 75%, 60%)",
  // },
  // {
  //   id: "texas",
  //   city: "Texas",
  //   region: "United States",
  //   address: "1220 River Bend Dr, Dallas, TX 75247, USA",
  //   imageUrl: "https://cdn.pixabay.com/photo/2023/04/18/17/14/ai-generated-7935610_640.jpg",
  //   color: "hsl(212, 72%, 59%)",
  // },
];

function HomePage() {
  const [expandedId, setExpandedId] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const scrollRef = useRef(null);
  // ================= APPRECIATION CAROUSEL STATE =================
  const [currentAppreciationIndex, setCurrentAppreciationIndex] = useState(0);
  const [selectedAppreciationImg, setSelectedAppreciationImg] = useState(null);
  const [isAppreciationPaused, setIsAppreciationPaused] = useState(false);

  const appreciationLetters = [
    {
      id: "sri-lanka-hc",
      category: "Government Project Appreciation",
      titlePrefix: "Recognition From ",
      titleHighlight: "Sri Lanka High Commission",
      description:
        "IT Softlab Consultancy Services Pvt. Ltd. received an official appreciation letter from the High Commission of the Democratic Socialist Republic of Sri Lanka for the successful development, deployment, and handover of the SLBPR reservation management system.",
      trustPoints: [
        "✓ Government Project Delivery",
        "✓ 100% Client Satisfaction",
        "✓ Enterprise Software Deployment",
        "✓ End-to-End Project Delivery",
        "✓ Technical Support & Handover",
        "✓ On-Time Project Delivery",
        "✓ Quality Assurance & Performance Optimization",
      ],
      stats: [
        { value: "100%", label: "Successful Deployment" },
        { value: "24/7", label: "Technical Support" },
        { value: "Govt.", label: "International Client" },
      ],
      imageSrc: "/images/appreciation/sri_lanka_appreciation.jpg",
      fileName: "Sri_Lanka_Appreciation_Letter.jpg",
    },
    {
      id: "proton-governance",
      category: "Corporate Governance Project Appreciation",
      titlePrefix: "Recognition From ",
      titleHighlight: "Proton Governance Group",
      description:
        "ITSoftlab Consultancy Services Pvt. Ltd. received an official letter of appreciation from Proton Governance Group for the outstanding work delivered in designing and developing their official website (www.protongovernancegroup.com).",
      trustPoints: [
        "✓ Corporate Website Design & Development",
        "✓ 100% Client Satisfaction",
        "✓ Creative Sensibility & Brand Identity",
        "✓ Complex Governance Content Translation",
        "✓ Strategic Web Design Partner",
        "✓ On-Time Project Delivery",
        "✓ Quality Assurance & Professional Integrity",
      ],
      stats: [
        { value: "100%", label: "Client Satisfaction" },
        { value: "Web", label: "Design & Development" },
        { value: "ESG", label: "Governance Advisory Client" },
      ],
      imageSrc: "/images/appreciation/proton_governance_appreciation.jpg",
      fileName: "Proton_Governance_Appreciation.jpg",
    },
    {
      id: "realty21-clinic",
      category: "Real Estate Tech & App Appreciation",
      titlePrefix: "Recognition From ",
      titleHighlight: "Realty21 Clinic Pvt. Ltd.",
      description:
        "ITSoftlab Consultancy Services Pvt. Ltd. received an official letter of appreciation from Realty21 Clinic Pvt. Ltd. for conceptualising, designing, and developing the Realty Gurukul App, empowering buyers and broker partners across Indore.",
      trustPoints: [
        "✓ Real Estate Platform & Mobile App",
        "✓ 100% Client Satisfaction",
        "✓ Broker Subscription & Listing Model",
        "✓ Technical Rigour & Speed Execution",
        "✓ End-to-End Product & App Development",
        "✓ On-Time Project Delivery",
        "✓ Successful Launch & Live Broker Expo",
      ],
      stats: [
        { value: "100%", label: "Successful App Launch" },
        { value: "Mobile", label: "iOS & Android Ecosystem" },
        { value: "Real Estate", label: "Trusted Tech Partner" },
      ],
      imageSrc: "/images/appreciation/realty21_appreciation.jpg",
      fileName: "Realty21_Appreciation_Letter.jpg",
    },
    {
      id: "physiocare",
      category: "Healthcare & Web Development Appreciation",
      titlePrefix: "Recognition From ",
      titleHighlight: "Dr. Manju Vishwakarma's Physiocare",
      description:
        "ITSoftlab Consultancy Services Pvt. Ltd. received an official letter of appreciation from Dr. Manju Vishwakarma's Physiocare for the excellent design and development of their official website and healthcare digital platform.",
      trustPoints: [
        "✓ Healthcare Digital Platform & Web Design",
        "✓ 100% Client Satisfaction",
        "✓ Patient-Centric & Engaging Design",
        "✓ Technical Expertise & Attention to Detail",
        "✓ End-to-End Web Development",
        "✓ On-Time Project Delivery",
        "✓ Trusted Technology Partner",
      ],
      stats: [
        { value: "100%", label: "Client Satisfaction" },
        { value: "Web", label: "Design & Development" },
        { value: "Healthcare", label: "Physiotherapy Portal" },
      ],
      imageSrc: "/images/appreciation/physiocare_appreciation.jpg",
      fileName: "Physiocare_Appreciation_Letter.jpg",
    },
    {
      id: "kln-ayurveda",
      category: "Herbal & Wellness E-Commerce Appreciation",
      titlePrefix: "Recognition From ",
      titleHighlight: "KLN Ayurveda Pvt. Ltd.",
      description:
        "ITSoftlab Consultancy Services Pvt. Ltd. received an official letter of appreciation from KLN Ayurveda Pvt. Ltd. for the professional and creative work delivered in designing and developing their official website and digital platform.",
      trustPoints: [
        "✓ E-Commerce & Wellness Website Design",
        "✓ 100% Client Satisfaction",
        "✓ Polished & User-Friendly Platform",
        "✓ Attentiveness to Finer Details",
        "✓ Technical Expertise & Creative Approach",
        "✓ On-Time Project Delivery",
        "✓ Dependable Technology Partner",
      ],
      stats: [
        { value: "100%", label: "Client Satisfaction" },
        { value: "Web", label: "Design & Development" },
        { value: "Ayurveda", label: "Herbal Luxury Platform" },
      ],
      imageSrc: "/images/appreciation/kln_ayurveda_appreciation.jpg",
      fileName: "KLN_Ayurveda_Appreciation_Letter.jpg",
    },
    {
      id: "mpvmavaks-union",
      category: "Government & Organization Union Portal Appreciation",
      titlePrefix: "Recognition From ",
      titleHighlight: "MPVMAVAKS Electricity Employees Union",
      description:
        "ITSoftlab Consultancy Services Pvt. Ltd. received an official letter of appreciation from MPVMAVAKS Electricity Employees Union for the excellent development and professional support in building their official website.",
      trustPoints: [
        "✓ Organization & Union Web Portal",
        "✓ 100% Client Satisfaction",
        "✓ Structured & Easy-to-Navigate Platform",
        "✓ Responsive to Organization Requirements",
        "✓ Effective Member Communication Tool",
        "✓ On-Time Project Delivery",
        "✓ Reliable Technology Partner",
      ],
      stats: [
        { value: "100%", label: "Client Satisfaction" },
        { value: "Portal", label: "Official Union Website" },
        { value: "Govt.", label: "Electricity Union Client" },
      ],
      imageSrc: "/images/appreciation/mpvmavaks_electricity_union_appreciation.jpg",
      fileName: "MPVMAVAKS_Electricity_Union_Appreciation.jpg",
    },
    {
      id: "crescita",
      category: "Digital Platform & Enterprise Web Appreciation",
      titlePrefix: "Recognition From ",
      titleHighlight: "Crescita",
      description:
        "ITSoftlab Consultancy Services Pvt. Ltd. received an official letter of appreciation from Crescita for the exceptional work carried out in designing and developing their official digital platform.",
      trustPoints: [
        "✓ Enterprise Digital Platform & Web Design",
        "✓ 100% Client Satisfaction",
        "✓ Functional & Professional Online Presence",
        "✓ Willingness to Accommodate Feedback",
        "✓ Strong Focus on Quality Standards",
        "✓ On-Time Project Delivery",
        "✓ Capable Technology Partner",
      ],
      stats: [
        { value: "100%", label: "Client Satisfaction" },
        { value: "Web", label: "Digital Platform" },
        { value: "Enterprise", label: "Brand Transformation" },
      ],
      imageSrc: "/images/appreciation/crescita_appreciation.jpg",
      fileName: "Crescita_Appreciation_Letter.jpg",
    },
        {
      id: "rm-group",
      category: "Corporate Digital Platform Appreciation",
      titlePrefix: "Recognition From ",
      titleHighlight: "RM Group of Companies",
      description:
        "ITSoftlab Consultancy Services Pvt. Ltd. received an official letter of appreciation from RM Group of Companies for the professional and high-quality work delivered in designing and developing their corporate digital platform.",
      trustPoints: [
        "✓ Corporate Website & Digital Platform",
        "✓ 100% Client Satisfaction",
        "✓ Clear & Organised Information Architecture",
        "✓ Attentive to Detail & Dedicated Support",
        "✓ End-to-End Web Development",
        "✓ On-Time Project Delivery",
        "✓ Trusted Technology Partner",
      ],
      stats: [
        { value: "100%", label: "Client Satisfaction" },
        { value: "Web", label: "Design & Development" },
        { value: "Corporate", label: "Enterprise Group Client" },
      ],
      imageSrc: "/images/appreciation/rm_group_appreciation.jpeg",
      fileName: "RM_Group_Appreciation_Letter.jpg",
    },
    {
      id: "upg-plumbing",
      category: "Professional Services & Platform Appreciation",
      titlePrefix: "Recognition From ",
      titleHighlight: "UPG Plumbing",
      description:
        "ITSoftlab Consultancy Services Pvt. Ltd. received an official letter of appreciation from UPG Plumbing for the professional work delivered in designing and developing their service platform, connecting customers efficiently.",
      trustPoints: [
        "✓ Professional Services Web Platform",
        "✓ 100% Client Satisfaction",
        "✓ User-Friendly & Organised Service Showcase",
        "✓ High Responsiveness & Attention to Detail",
        "✓ Efficient Customer Connection Portal",
        "✓ On-Time Project Delivery",
        "✓ Reliable Technology Partner",
      ],
      stats: [
        { value: "100%", label: "Client Satisfaction" },
        { value: "Web", label: "Service Platform" },
        { value: "24/7", label: "Customer Reach" },
      ],
      imageSrc: "/images/appreciation/upg_plumbing_appreciation.jpeg",
      fileName: "UPG_Plumbing_Appreciation_Letter.jpg",
    },
    {
      id: "mr-group",
      category: "Enterprise Digital Platform Appreciation",
      titlePrefix: "Recognition From ",
      titleHighlight: "MR Group of Companies",
      description:
        "ITSoftlab Consultancy Services Pvt. Ltd. received an official letter of appreciation from MR Group of Companies for their strong combination of technical expertise, creative thinking, and professionalism in developing their digital platform.",
      trustPoints: [
        "✓ Enterprise Digital Platform & Web Solution",
        "✓ 100% Client Satisfaction",
        "✓ Structured & Professional Online Presence",
        "✓ Responsive Communication & Finer Detail",
        "✓ End-to-End Design & Development",
        "✓ On-Time Project Delivery",
        "✓ Dependable Technology Partner",
      ],
      stats: [
        { value: "100%", label: "Client Satisfaction" },
        { value: "Web", label: "Enterprise Platform" },
        { value: "Group", label: "Multi-Industry Client" },
      ],
      imageSrc: "/images/appreciation/mr_group_appreciation.jpeg",
      fileName: "MR_Group_Appreciation_Letter.jpg",
    },
    {
      id: "single-step-associates",
      category: "Consulting & Professional Services Appreciation",
      titlePrefix: "Recognition From ",
      titleHighlight: "Single Step Associates",
      description:
        "ITSoftlab Consultancy Services Pvt. Ltd. received an official letter of appreciation from Single Step Associates for the professional and dedicated work undertaken in designing and developing their digital platform.",
      trustPoints: [
        "✓ Professional Services Web Design",
        "✓ 100% Client Satisfaction",
        "✓ Clean, Structured & Accessible UI/UX",
        "✓ Smooth Coordination & Quality Execution",
        "✓ Tailored Business Architecture",
        "✓ On-Time Project Delivery",
        "✓ Dependable Technology Partner",
      ],
      stats: [
        { value: "100%", label: "Client Satisfaction" },
        { value: "Web", label: "Consulting Platform" },
        { value: "Corporate", label: "Associates Partner" },
      ],
      imageSrc: "/images/appreciation/single_step_associates_appreciation.jpeg",
      fileName: "Single_Step_Associates_Appreciation_Letter.jpg",
    },
    {
      id: "reality-gurukul",
      category: "Real Estate Education & Portal Appreciation",
      titlePrefix: "Recognition From ",
      titleHighlight: "Reality Gurukul (R-21)",
      description:
        "ITSoftlab Consultancy Services Pvt. Ltd. received an official letter of appreciation from Reality Gurukul for the excellent work delivered in designing and developing their modern real estate educational and digital platform.",
      trustPoints: [
        "✓ Real Estate Training & Educational Platform",
        "✓ 100% Client Satisfaction",
        "✓ Modern, Clear & Engaging User Interface",
        "✓ Attentive to Detail & Technical Rigour",
        "✓ Idea-to-Execution Digital Transformation",
        "✓ On-Time Project Delivery",
        "✓ Reliable & Capable Technology Partner",
      ],
      stats: [
        { value: "100%", label: "Client Satisfaction" },
        { value: "Web", label: "Educational Platform" },
        { value: "EdTech", label: "Real Estate Academy" },
      ],
      imageSrc: "/images/appreciation/reality_gurukul_appreciation.jpeg",
      fileName: "Reality_Gurukul_Appreciation_Letter.jpg",
    },
        {
      id: "urja-sankul",
      category: "Institutional & Energy Platform Appreciation",
      titlePrefix: "Recognition From ",
      titleHighlight: "Urja Sankul",
      description:
        "ITSoftlab Consultancy Services Pvt. Ltd. received an official letter of appreciation from Urja Sankul for their technical expertise, creativity, and dedication in designing and developing their official digital platform.",
      trustPoints: [
        "✓ Institutional Digital Platform & Web Solution",
        "✓ 100% Client Satisfaction",
        "✓ Well-Structured, Professional & User-Friendly UI",
        "✓ High Technical Expertise & Creative Execution",
        "✓ Prompt Responsiveness & Cooperative Approach",
        "✓ On-Time Project Delivery",
        "✓ Reliable Technology Partner",
      ],
      stats: [
        { value: "100%", label: "Client Satisfaction" },
        { value: "Web", label: "Digital Platform" },
        { value: "Energy", label: "Institutional Portal" },
      ],
      imageSrc: "/images/appreciation/urja_sankul_appreciation.jpeg",
      fileName: "Urja_Sankul_Appreciation_Letter.jpg",
    },
  ];

  const nextAppreciation = () => {
    setCurrentAppreciationIndex((prev) => (prev + 1) % appreciationLetters.length);
  };

  const prevAppreciation = () => {
    setCurrentAppreciationIndex(
      (prev) => (prev - 1 + appreciationLetters.length) % appreciationLetters.length
    );
  };

  // Auto-play timer for slider (pauses when user hovers)
  useEffect(() => {
    if (isAppreciationPaused || selectedAppreciationImg) return;
    const interval = setInterval(() => {
      nextAppreciation();
    }, 6000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAppreciationPaused, selectedAppreciationImg]);

   // ================= APPRECIATION SWIPE, TOUCHPAD & 1-TAP HANDLERS =================
  const appreciationCardRef = useRef(null);
  const dragStartX = useRef(0);
  const isDraggingAppreciation = useRef(false);
  const isWheelCoolingDown = useRef(false);

  // 💻 1. Touchpad Two-Finger Swipe (Mac & Windows Touchpad)
  const handleWheel = (e) => {
    // Detect horizontal swipe, or shift + wheel
    const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
    if (Math.abs(delta) > 20) {
      if (isWheelCoolingDown.current) return;
      isWheelCoolingDown.current = true;

      if (delta > 0) {
        nextAppreciation();
      } else {
        prevAppreciation();
      }

      setTimeout(() => {
        isWheelCoolingDown.current = false;
      }, 450);
    }
  };

  // 🖱️ 2. Desktop Mouse / Touchpad Click & Drag (With Pointer Capture)
  const handlePointerDown = (e) => {
    // Ignore touch here (handled separately by touch listeners)
    if (e.pointerType === "touch") return;
    if (e.button !== 0) return; // Only primary button
    if (e.target.closest("button") || e.target.closest("a") || e.target.closest(".open-letter-btn")) return;

    isDraggingAppreciation.current = true;
    dragStartX.current = e.clientX;
    try {
      e.currentTarget.setPointerCapture(e.pointerId);
    } catch (err) {}
  };

  const handlePointerUp = (e) => {
    if (e.pointerType === "touch" || !isDraggingAppreciation.current) return;
    isDraggingAppreciation.current = false;
    const diff = dragStartX.current - e.clientX;

    try {
      if (e.currentTarget.hasPointerCapture(e.pointerId)) {
        e.currentTarget.releasePointerCapture(e.pointerId);
      }
    } catch (err) {}

    // Dragged more than 35px
    if (diff > 35) {
      nextAppreciation();
    } else if (diff < -35) {
      prevAppreciation();
    }
  };

  const handlePointerCancel = (e) => {
    if (e.pointerType === "touch") return;
    isDraggingAppreciation.current = false;
    try {
      if (e.currentTarget.hasPointerCapture(e.pointerId)) {
        e.currentTarget.releasePointerCapture(e.pointerId);
      }
    } catch (err) {}
  };

  // 📱 3. Mobile: Swipe OR 1-Tap Slide
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    // Ignore taps on buttons or the zoom modal button
    if (e.target.closest(".open-letter-btn") || e.target.closest("button") || e.target.closest("a")) return;

    const diff = touchStartX.current - touchEndX.current;

    // 1️⃣ If swiped with finger (> 35px)
    if (diff > 35) {
      nextAppreciation();
    } else if (diff < -35) {
      prevAppreciation();
    } 
    // 2️⃣ If ONLY 1-TAP (< 15px movement)
    else if (Math.abs(diff) < 15) {
      const cardRect = appreciationCardRef.current?.getBoundingClientRect();
      if (cardRect) {
        const tapX = touchStartX.current - cardRect.left;
        // Tap on left 35% goes previous; tap anywhere else goes next
        if (tapX < cardRect.width * 0.35) {
          prevAppreciation();
        } else {
          nextAppreciation();
        }
      } else {
        nextAppreciation();
      }
    }
  };

  const isHovered = false;
  // const [isDragging, setIsDragging] = useState(false);
  // const [startX, setStartX] = useState(0);
  // const [scrollLeft, setScrollLeft] = useState(0);

  // const wrapperRef = useRef(null);
  const isDragging = useRef(false);
  // const startX = useRef(0);
  // const scrollLeft = useRef(0);
  const [openIndex, setOpenIndex] = useState(null);
  // const [scrollPosition, setScrollPosition] = useState(0);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const [isScrolled, setIsScrolled] = useState(false);
  const imageContainer = useRef(null);
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [autoplay, setAutoplay] = useState(true);
  const autoplayRef = useRef(null);

  // const [position, setPosition] = useState(0);

  // const itemWidth = 300;
  // const gap = 24;
  // const animationSpeed = 30;

  // const totalWidth = itemWidth + gap;

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  // const handleMouseDown = (e) => {
  //   isDragging.current = true;
  //   startX.current = e.pageX - (wrapperRef.current?.offsetLeft || 0);
  //   scrollLeft.current = wrapperRef.current?.scrollLeft || 0;
  // };

  // const handleMouseMove = (e) => {
  //   if (!isDragging.current) return;
  //   e.preventDefault();
  //   const x = e.pageX - (wrapperRef.current?.offsetLeft || 0);
  //   const walk = (x - startX.current) * 2; // Drag speed
  //   if (wrapperRef.current) {
  //     wrapperRef.current.scrollLeft = scrollLeft.current - walk;
  //   }
  // };

  // const handleMouseUp = () => {
  //   isDragging.current = false;
  // };

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let animationFrameId;

    const smoothScroll = () => {
      if (!isHovered && !isDragging) {
        scrollContainer.scrollLeft += 0.5; // Speed: 0.5px per frame
        if (
          scrollContainer.scrollLeft >=
          scrollContainer.scrollWidth - scrollContainer.clientWidth
        ) {
          scrollContainer.scrollLeft = 0; // Infinite Loop
        }
      }
      animationFrameId = requestAnimationFrame(smoothScroll);
    };

    smoothScroll();

    return () => cancelAnimationFrame(animationFrameId);
  }, [isHovered, isDragging]);

  // useEffect(() => {
  //   const animate = () => {
  //     setPosition((prevPos) => {
  //       const newPos = prevPos - 1;
  //       if (Math.abs(newPos) >= 6 * totalWidth) {
  //         return 0;
  //       }
  //       return newPos;
  //     });
  //   };

  //   const interval = setInterval(animate, animationSpeed);
  //   return () => clearInterval(interval);
  // }, [totalWidth, setPosition]);

  const nextTestimonial = () => {
    setActiveTestimonial((prev) =>
      prev === clients.length - 1 ? 0 : prev + 1,
    );
  };
  const prevTestimonial = () => {
    setActiveTestimonial((prev) =>
      prev === 0 ? clients.length - 1 : prev - 1,
    );
  };

  useEffect(() => {
    gsap.fromTo(
      imageContainer.current,
      { opacity: 0, scale: 0.9 },
      { opacity: 1, scale: 1, duration: 1.2 },
    );
  }, []);

  // Autoplay functionality
  useEffect(() => {
    if (autoplay) {
      autoplayRef.current = setInterval(() => {
        nextTestimonial();
      }, 3000);
    }

    return () => {
      if (autoplayRef.current) {
        clearInterval(autoplayRef.current);
      }
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoplay, activeTestimonial]);

  // const handleMouseEnter = () => setAutoplay(true);
  // const handleMouseLeave = () => setAutoplay(true);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const benefits = [
    "End-to-End IT Solution",
    "Cybersecurity & Data Protection",
    "Cloud & Remote Work Solutions",
    "AI-Powered Business Automation",
    "Custom Software Development",
    "Web & Mobile App Development",
    "AI & Automation Solutions",
    "IT Support & Helpdesk Services",
  ];

  const stats = useMemo(
    () => [
      { id: 1, type: "stars", label: "Google Reviews", sub: "5 out of 5", logoType: "google" },
      { id: 2, type: "stars", label: "AmbitionBox", sub: "5 out of 5", logoType: "ambitionbox" },
    ],
    [],
  );
  const sectionRef = useRef(null);
  const statRefs = useRef([]);

  const clients = [
    {
      id: 0,
      name: "Lakshmendra Dissanayake",
      position: "Deputy Director",
      company: "Sri Lankan High Commission, India",
      image: "/images/slbpr.jpg",
      testimonial:
        "We are highly satisfied with the successful delivery of the SLBPR booking platform. The team demonstrated strong technical expertise, professionalism, and a clear understanding of our requirements. The system has significantly improved our reservation management and operational efficiency.",
      rating: 5,
    },
    {
      id: 1,
      name: "Liam Anderson",
      position: "Senior Automation Engineer, FlowTech Solutions",
      company: " Industrial Automation, PLC Integration, Process Optimization",
      image: "/images/liam.png",
      testimonial:
        "Liam Anderson was facing repeated downtimes in his assembly unit due to outdated systems. After collaborating with ITSoftlab, he successfully integrated smart sensors and automation panels. Downtime reduced by 60%, and productivity skyrocketed.",
      rating: 5,
    },
    {
      id: 2,
      name: "Olivia Brooks",
      position: "Plant Manager, NovaTech Industries",
      company: "Quality Control, Project Management, AI Integration",
      image: "/images/olivia.png",
      testimonial:
        "Olivia Brooks led a major upgrade project using ITSoftlab’s AI-based inspection systems. Under her leadership, defect rates dropped significantly, and product quality reached international standards.",
      rating: 5,
    },
    {
      id: 3,
      name: "Ethan Parker",
      position: "Mechanical Design Engineer, Mechtronix Pvt. Ltd.",
      company: "CAD Designing, Process Engineering, Modular Systems",
      image: "/images/ethan.png",
      testimonial:
        "Ethan Parker redesigned their packaging unit with the help of ITSoftlab's modular solutions. The result was a 40% increase in speed without compromising accuracy. His design became the new standard for future expansions.",
      rating: 5,
    },
    {
      id: 4,
      name: "Emma Sullivan",
      position: "Head of Innovation, SteelForge Group",
      company: "R&D, Sustainable Manufacturing, Energy Efficiency",
      image: "/images/emma.png",
      testimonial:
        "Emma Sullivan partnered with ITSoftlab to test and implement an energy-saving conveyor system. The pilot project not only saved power but also earned her team an industry award.",
      rating: 4,
    },
    {
      id: 5,
      name: "Noah Bennett",
      position: "Electrical Engineer, ElecMaster Automation",
      company: "Circuit Design, Load Balancing, Smart Control Systems",
      image: "/images/noah.png",
      testimonial:
        "Noah Bennett implemented ITSoftlab’s smart control units in their HVAC manufacturing line. His proactive approach helped reduce electrical faults and optimize load management.",
      rating: 5,
    },
    {
      id: 6,
      name: "Ava Mitchell",
      position: "Operations Supervisor, ThermoFab Ltd.",
      company: "Operations Analysis, Real-time Monitoring, Team Leadership",
      image: "/images/ava.png",
      testimonial:
        "With ITSoftlab’s real-time monitoring systems, Ava was able to identify bottlenecks in the heat treatment section and resolve them efficiently. The plant saw a 25% boost in throughput.",
      rating: 4,
    },
    {
      id: 7,
      name: "Lucas Hayes",
      position: "Maintenance Lead, Machino Industries",
      company: "Predictive Maintenance, Fault Detection, Preventive Planning",
      image: "/images/lucas.png",
      testimonial:
        "Lucas Hayes introduced predictive maintenance tools from ITSoftlab into his team’s workflow. Unexpected failures dropped, maintenance costs went down, and uptime hit a record high.",
      rating: 4,
    },
  ];

  // const teamMembers = [
  //   {
  //     name: "Rahul Chourasiya",
  //     position: "FullStack Developer",
  //     image: "/images/rahul.png",
  //     bio: "As a FullStack Developer, I build robust, scalable web applications from front-end interfaces to back-end systems. I specialize in JavaScript frameworks, RESTful APIs, and modern databases to deliver seamless user experiences. With a strong foundation in both client and server-side technologies.",
  //     social: {
  //       // linkedin: "#",
  //       // twitter: "#",
  //       // email: "michael@example.com",
  //     },
  //   },

  //   {
  //     name: "Fazleen Deena",
  //     position: "product Manager",
  //     image: "/images/ff1.png",
  //     bio: "As a Product Manager, I bridge the gap between user needs and technical solutions. With a keen eye for design and deep collaboration with development teams, I turn complex ideas into products that are intuitive, engaging, and scalable.",
  //     social: {},
  //   },
  //   {
  //     name: "Nikhil Basrani",
  //     position: "AI and Cloud Engineer",
  //     image: "/images/nikhil.png",
  //     bio: "Hey, I’m Specializes in bringing ML models to life, training and deploying on AWS and GCP to turn scalable solutions and algorithms into real-world applications.",
  //     social: {},
  //   },

  //   {
  //     name: "Sameer Sharma",
  //     position: "FullStack Developer",
  //     image: "/images/sameer.jpg",
  //     bio: "As a Full-Stack Developer, I design and develop end-to-end web applications, combining efficient backend logic with intuitive frontend interfaces, while ensuring scalability, performance, and seamless user experience.",
  //     social: {},
  //   },
  //   {
  //     name: "Swati Mishra",
  //     position: "Mern Stack",
  //     image: "/images/swati.png",
  //     bio: " I'm a Mern Stack Developer specializing in MongoDB, Express.js, React, and Node.js. I build modern, fast, and secure web applications tailored to client requirements with clean, maintainable code.",
  //     social: {},
  //   },

  //   {
  //     name: " Mathew Forster",
  //     position: "Data Analyst",
  //     image: "/images/ff4.png",
  //     bio: "Hi, I’m Mathew Forster—a Data Analyst passionate about transforming raw data into actionable insights. With expertise in tools like SQL, Python, Excel, and Tableau, I specialize in uncovering trends, optimizing business performance, and delivering clear, data-driven recommendations.",
  //     social: {},
  //   },

  //   {
  //     name: "Smita Choudhary",
  //     position: "Mern Developer",
  //     image: "/images/smita.png",
  //     bio: "She is skilled MERN Developer, known for delivering exceptional MERN projects that are both robust and efficient. She has a strong command over API integration, ensuring seamless communication between front-end and back-end systems.",
  //     social: {},
  //   },
  //   {
  //     name: "Pratham Verma",
  //     position: "Lead Developer",
  //     image: "/images/pratham.jpg",
  //     bio: "As a software engineer, I specialize in transforming complex requirements into efficient, scalable solutions, with a strong focus on code quality, performance, and continuous improvement.",
  //     social: {},
  //   },

  //   {
  //     name: "Sofia Rossi",
  //     position: "Data Scientist",
  //     image: "/images/ff2.png",
  //     bio: "Hello, I’m Sofia Rossi — I transform raw data into actionable insights using Python, SQL, and machine learning. From building recommendation engines to customer segmentation, I help businesses become data-driven.",
  //     social: {},
  //   },

  //   {
  //     name: " Johnson Minz",
  //     position: "DevOps & Cloud Infrastructure Engineer",
  //     image: "/images/kelvin.jpeg",
  //     bio: "Automate deployment pipelines and manage scalable infrastructures on AWS, Azure, and Kubernetes. My work ensures your product scales smoothly from MVP to millions of users",
  //     social: {},
  //   },

  //   {
  //     name: "Harshit Nigam",
  //     position: "FullStack Java Developer",
  //     image: "/images/harshit.jpg",
  //     bio: "Highly skilled in Java, React, Spring Boot, and modern web technologies. With expertise in both front-end and back-end development, specializing in building dynamic, scalable applications and delivering high-quality solutions.",
  //     social: {},
  //   },

  //   {
  //     name: "Rishita Chaturvedi",
  //     position: "Mern Developer",
  //     image: "/images/rishita.png",
  //     bio: "Rishita has exceptional expertise in creating intuitive and visually appealing, consistently delivering high-quality work. She is highly skilled in translating user requirements into seamless interfaces that provide an outstanding user experience. ",
  //     social: {},
  //   },

  //   {
  //     name: "Mohit Maleshiya",
  //     position: "FullStack Developer",
  //     image: "/images/mohit.jpeg",
  //     bio: "Full Stack Next.js, Java, MERN Developer, skilled in building scalable and responsive web applications. Passionate about clean code, UI/UX, and solving real-world problems through modern web technologies.",
  //     social: {},
  //   },

  //     {
  //     name: "Neha Gautam",
  //     position: "Business Development Manager",
  //     image: "/images/neha.png",
  //     bio: "Hi, I'm Neha — a Techno-Business Consultant turned Business Development Manager with over 6 years of experience in the IT industry. I specialize in bridging technology and strategy to drive business growth, foster strong client relationships, and deliver impactful digital solutions.",
  //     social: {},
  //   },

  //   {
  //     name: "Ashutosh Dhayade",
  //     position: "Account Manager",
  //     image: "/images/ashutosh.png",
  //     bio: "Experienced in managing key accounts, building strong client relationships, and developing strategies that drive business growth. Skilled at aligning client needs with solutions, resolving issues efficiently, and identifying opportunities to expand revenue and improve retention.",
  //     social: {},
  //   },

  //   {
  //     name: "Freya Olsen",
  //     position: "Mobile App Developer (Flutter & React Native)",
  //     image: "/images/ff5.png",
  //     bio: "Hey, I’m Freya Olsen — I build cross-platform mobile apps that are fast, beautiful, and user-friendly. Whether it’s a startup MVP or enterprise app, I deliver pixel-perfect mobile solutions that scale.",
  //     social: {},
  //   },

  //   {
  //     name: "Vishwas Dangar",
  //     position: "FullStack Developer",
  //     image: "/images/vishwas.png",
  //     bio: "From designing responsive interfaces to building powerful backend systems, I develop full-stack applications that are both functional and future-ready. I specialize in crafting intuitive user experiences, scalable APIs, and clean, maintainable code.",
  //     social: {},
  //   },

  //   {
  //     name: "Priya Tiwari",
  //     position: "Business Analyst",
  //     image: "/images/priya.png",
  //     bio: "I'm a Business Analyst, helping bridge client needs with smart IT solutions to drive measurable business growth. I specialize in gathering and analyzing requirements, aligning cross-functional teams, and turning data into actionable insights.",
  //     social: {},
  //   },

  //   {
  //     name: "Hritik Yadav",
  //     position: "Business Analyst (Pre Sales)",
  //     image: "/images/hritik.jpeg",
  //     bio: "Fuelled by curiosity and driven by innovation, I turn complex ideas into impactful actions—blending tech, business, and AI to shape smarter solutions Business development expert and AI enthusiast.",
  //     social: {},
  //   },

  //   {
  //     name: "Ethen James",
  //     position: "Cybersecurity Analyst",
  //     image: "/images/ethen.png",
  //     bio: "Hi, I’m Ethen James — a security-first thinker with expertise in penetration testing, network security, and incident response. I help startups and enterprises safeguard their infrastructure and comply with global standards.",
  //     social: {},
  //   },

  //   {
  //     name: "Niteen Yadav",
  //     position: "Business Analyst",
  //     image: "/images/nitin.png",
  //     bio: "Passionate problem solver blending tech and strategy to turn ideas into impact and challenges into opportunities. I thrive on identifying innovative solutions that drive efficiency, streamline processes, and enhance business outcomes.",
  //     social: {},
  //   },

  //   {
  //     name: "Khushi Chadda",
  //     position: "UI/UX Developer",
  //     image: "/images/khushi.png",
  //     bio: "As a UI/UX developer, I specialize in designing intuitive, user-centric interfaces that bridge functionality with aesthetics. I focus on creating seamless user experiences through thoughtful design, usability testing, and responsive layout ensuring both accessibility and performance across platforms.",
  //     social: {},
  //   },

  // ];

  // logos slider
  const clientLogos = [
    {
      id: 101,
      name: "Sri Lanka Government",
      logo: "/images/slbpr-images/slbpr-logo.jpg",
    },
    {
      id: 1,
      name: "Microsoft",
      logo: "/images/a.png",
    },
    {
      id: 2,
      name: "Google",
      logo: "/images/d.png",
    },
    {
      id: 3,
      name: "Amazon",
      logo: "/images/c.png",
    },
    {
      id: 32,
      name: "Salesforce",
      logo: "/images/g1.png",
    },
    {
      id: 33,
      name: "Salesforce",
      logo: "/images/h1.png",
    },
    {
      id: 4,
      name: "IBM",
      logo: "/images/f.png",
    },
    // {
    //   id: 5,
    //   name: "Oracle",
    //   logo: "/images/e.png",
    // },
    {
      id: 6,
      name: "Salesforce",
      logo: "/images/b.png",
    },
    {
      id: 7,
      name: "Google",
      logo: "/images/g.png",
    },
    {
      id: 8,
      name: "Amazon",
      logo: "/images/h.png",
    },
    {
      id: 9,
      name: "IBM",
      logo: "/images/k.png",
    },
    {
      id: 10,
      name: "O  racle",
      logo: "/images/j.png",
    },

    {
      id: 36,
      name: "Salesforce",
      logo: "/images/k1.png",
    },
    {
      id: 23,
      name: "Salesforce",
      logo: "/images/x.png",
    },
    {
      id: 21,
      name: "Salesforce",
      logo: "/images/v.png",
    },
    {
      id: 22,
      name: "Salesforce",
      logo: "/images/w.png",
    },
    {
      id: 26,
      name: "Salesforce",
      logo: "/images/a1.png",
    },
    {
      id: 28,
      name: "Salesforce",
      logo: "/images/c1.png",
    },

    {
      id: 24,
      name: "Salesforce",
      logo: "/images/y.png",
    },
    {
      id: 39,
      name: "Salesforce",
      logo: "/images/n1.png",
    },
    // {
    //   id: 40,
    //   name: "Salesforce",
    //   logo: "/images/aws.png",
    // },
    {
      id: 25,
      name: "Salesforce",
      logo: "/images/z.png",
    },
    {
      id: 15,
      name: "Salesforce",
      logo: "/images/p.png",
    },
    {
      id: 16,
      name: "Salesforce",
      logo: "/images/q.png",
    },
    // {
    //   id: 41,
    //   name: "Salesforce",
    //   logo: "/images/p1.png",
    // },
    {
      id: 27,
      name: "Salesforce",
      logo: "/images/b1.png",
    },
    {
      id: 29,
      name: "Salesforce",
      logo: "/images/d1.png",
    },
    {
      id: 30,
      name: "Salesforce",
      logo: "/images/e1.png",
    },
    {
      id: 13,
      name: "Salesforce",
      logo: "/images/n.png",
    },
    {
      id: 38,
      name: "Salesforce",
      logo: "/images/m1.png",
    },
    {
      id: 14,
      name: "Salesforce",
      logo: "/images/o.png",
    },

    {
      id: 17,
      name: "Salesforce",
      logo: "/images/r.png",
    },
    {
      id: 11,
      name: "Salesforce",
      logo: "/images/i.png",
    },
    {
      id: 12,
      name: "Salesforce",
      logo: "/images/l.png",
    },
    {
      id: 18,
      name: "Salesforce",
      logo: "/images/s.png",
    },
    {
      id: 19,
      name: "Salesforce",
      logo: "/images/t.png",
    },
    {
      id: 20,
      name: "Salesforce",
      logo: "/images/u.png",
    },
    {
      id: 37,
      name: "Salesforce",
      logo: "/images/l1.png",
    },

    {
      id: 35,
      name: "Salesforce",
      logo: "/images/j1.png",
    },

    {
      id: 34,
      name: "Salesforce",
      logo: "/images/i1.png",
    },

    {
      id: 31,
      name: "Salesforce",
      logo: "/images/f1.png",
    },
  ];

  useEffect(() => {
    statRefs.current.forEach((stat, index) => {
      const value = stats[index].value;

      const numericValue = parseFloat(value); // Supports decimals like 4.9
      const suffix = String(value).replace(/[0-9.]/g, "");

      gsap.fromTo(
        stat,
        { innerText: 0 },
        {
          innerText: numericValue,
          duration: 3.5,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 80%",
            once: true,
          },
          onUpdate: function () {
            stat.innerText =
              Number(stat.innerText).toFixed(
                numericValue % 1 !== 0 ? 1 : 0
              ) + suffix;
          },
          onComplete: function () {
            stat.innerText =
              numericValue.toFixed(numericValue % 1 !== 0 ? 1 : 0) + suffix;
          },
        }
      );
    });
  }, [stats]);

  return (
    <>
      <div className="four-iiccoonnss">
        {/* <div className="fourr">
          Email
          <i class="fa-solid fa-envelope"></i>
        </div> */}

        {/* <div className="three">
          Twitter
          <i class="fa-brands fa-x-twitter"></i>
        </div> */}

        <div className="twoo">
          <a
            rel="noopener noreferrer"
            href="https://www.linkedin.com/company/ITSoftlab/posts/?feedView=all"
            target="_blank"
          >
            Linkedin
          </a>
          <i class="fa-brands fa-linkedin-in"></i>
        </div>

        <div className="onee">
          <a
            rel="noopener noreferrer"
            href="https://api.whatsapp.com/send/?phone=%2B917898822644&text&type=phone_number&app_absent=0"
            target="_blank"
          >
            Whatsapp
          </a>
          <i class="fa-brands fa-whatsapp"></i>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          overflow: "hidden",
          width: "100%",
          height: "100%",
          minHeight: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Navbar />
        <SlbprProjectPopup />
        <div className="video-container">
          <video autoPlay loop muted playsInline>
            <source
              // src="https://cdn.pixabay.com/video/2020/07/29/45902-447070777_large.mp4"

              // src="https://cdn.pixabay.com/video/2023/04/13/158756-817470865_tiny.mp4"
              src="https://cdn.pixabay.com/video/2020/08/12/46965-449623750_large.mp4"
              // src="https://videos.pexels.com/video-files/3191573/3191573-uhd_2560_1440_25fps.mp4"
              // src="https://cdn.pixabay.com/video/2024/12/23/248384_large.mp4"
              // src="https://cdn.pixabay.com/video/2025/03/22/266703_large.mp4"

              // src="https://cdn.pixabay.com/video/2017/06/11/9809-221185519_large.mp4"

              // src="https://cdn.pixabay.com/video/2017/06/11/9809-221185519_large.mp4"
              // src="https://cdn.pixabay.com/video/2021/10/12/91744-636709154_tiny.mp4"
              // src="https://cdn.pixabay.com/video/2024/06/01/214888_tiny.mp4"
              type="video/mp4"
            />
          </video>
        </div>
        {/* <div className="video-container">
          <video autoPlay loop muted playsInline>
            <source
              src="https://cdn.pixabay.com/video/2021/10/12/91744-636709154_tiny.mp4"
              type="video/mp4"
            />
          </video>
        </div> */}
        <section className="hsection">
          <div className={`hcontainer ${isScrolled ? "scrolled-con" : ""}`}>
            <div className="hcontent-grid">
              {/* Left Section */}
              <motion.div
                className="aaaaaa"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                {/* <h1 className="htitle">
                  Trusted Best IT <span className="hhighlight">Company</span>
                </h1> */}
                <h1 className="htitle">
                  Empowering Business Through Innovative<br />
                  <span style={{ color: "#00BFFF" }}>IT Solutions</span>
                </h1>

                <p className="hsubtitle">
                  At IT Softlab, we provide end-to-end 360° digital solutions through a blend of innovative products and professional IT services. Our expertise spans custom software development, AI-powered platforms, cloud solutions, enterprise systems, and business automation. We help organizations transform challenges into opportunities with secure, scalable, and future-ready technology solutions designed for long-term success.
                </p>



                {/* Social Media Icons */}
                {/* <div className="hsocial-icons">
                  <a
                    href="https://wa.me/yourwhatsapplink"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaWhatsapp className="iccon" />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/yourprofile"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedin className="iccon" />
                  </a>
                  <a
                    href="https://twitter.com/yourprofile"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaTwitter className="iccon" />
                  </a>
                  <a href="mailto:your@email.com">
                    <FaEnvelope className="iccon" />
                  </a>
                </div> */}
              </motion.div>

              {/* Right Section - Image Gallery */}
              <div className="highlights-container">
                {/* Services Card */}
                <div className="highlight-card services-card">
                  <div className="icon"></div>
                  <h2>End-to-End Tech Services Under One Roof</h2>
                  <p>
                    Whether it’s AI, Cloud, Cybersecurity, Mobile Apps, or
                    DevOps — we provide full-stack technology services designed
                    to scale with your business.
                  </p>
                  <a href="/servicespage">
                    <button>Explore Our Services</button>
                  </a>
                </div>

                {/* Products Card */}
                <div className="highlight-card products-card">
                  <div className="icon"></div>
                  <h2>
                    Smart Industry-Specific Products That Simplify Business
                  </h2>
                  <p>
                    From CRM systems to HRMS, invoicing tools, and inventory
                    management — our products are crafted to fit your industry’s
                    unique needs.
                  </p>
                  <a href="/products">
                    <button>View All Products</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* ================= Premium Appreciation Section (Swipeable Carousel) ================= */}
      <section className="appreciation-section">
        <div className="appreciation-bg-glow"></div>

        <div className="appreciation-header">
          <span className="appreciation-tag">✦ Client Recognition</span>
          <h2>Appreciation Letters & Success Recognition</h2>
        </div>

        {/* Carousel Container */}
               {/* Carousel Container with Desktop Drag & Mobile 1-Tap */}
        <div
          ref={appreciationCardRef}
          className="appreciation-carousel-wrapper appreciation-swipeable"
          onMouseEnter={() => setIsAppreciationPaused(true)}
          onMouseLeave={() => setIsAppreciationPaused(false)}
          onWheel={handleWheel}
          onPointerDown={handlePointerDown}
          onPointerUp={handlePointerUp}
          onPointerCancel={handlePointerCancel}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {/* Previous Slide Arrow */}
          <button
            className="slider-arrow arrow-left"
            onClick={prevAppreciation}
            aria-label="Previous Letter"
          >
            ‹
          </button>

          {/* Current Active Slide */}
          {(() => {
            const currentItem = appreciationLetters[currentAppreciationIndex];
            return (
              <div className="appreciation-card" key={currentItem.id}>
                {/* LEFT SIDE: Information */}
                <div className="appreciation-content">
                  <div className="featured-line">
                    <div className="pulse-dot"></div>
                    {currentItem.category}
                  </div>

                  <h3>
                    {currentItem.titlePrefix}
                    <span>{currentItem.titleHighlight}</span>
                  </h3>

                  <p>{currentItem.description}</p>

                  <div className="trust-points">
                    {currentItem.trustPoints.map((point, idx) => (
                      <div className="trust-item" key={idx}>
                        {point}
                      </div>
                    ))}
                  </div>

                  <div className="appreciation-stats">
                    {currentItem.stats.map((stat, idx) => (
                      <div className="stat-box" key={idx}>
                        <span className="stat-value">{stat.value}</span>
                        <span className="stat-label">{stat.label}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* RIGHT SIDE: Letter Photo */}
                <div className="pdf-showcase">
                  <div className="letter-showcase">
                    <div className="letter-glow"></div>

                    <div className="letter-card">
                      <div className="letter-topbar">
                        <div className="dots">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                        <span className="file-name">{currentItem.fileName}</span>
                      </div>

                      <div
                        className="letter-preview"
                        onClick={() => setSelectedAppreciationImg(currentItem.imageSrc)}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={currentItem.imageSrc}
                          alt={`${currentItem.titleHighlight} Appreciation Letter`}
                        />
                        <div className="letter-overlay">
                          <span className="open-letter-btn">
                            🔍 Click to View Full Letter
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })()}

          {/* Next Slide Arrow */}
          <button
            className="slider-arrow arrow-right"
            onClick={nextAppreciation}
            aria-label="Next Letter"
          >
            ›
          </button>

          {/* Indicators & Counter */}
          <div className="carousel-controls">
            <div className="carousel-dots">
              {appreciationLetters.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${index === currentAppreciationIndex ? "active" : ""}`}
                  onClick={() => setCurrentAppreciationIndex(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
            <span className="slide-counter">
  {String(currentAppreciationIndex + 1).padStart(2, "0")} / {String(appreciationLetters.length).padStart(2, "0")}
</span>
          </div>
        </div>
      </section>

      {/* Image Modal for Full View */}
      {selectedAppreciationImg && (
        <div
          className="pdf-modal-overlay"
          onClick={() => setSelectedAppreciationImg(null)}
        >
          <div
            className="img-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="pdf-modal-close img-modal-close"
              onClick={() => setSelectedAppreciationImg(null)}
            >
              ✕
            </button>
            <img
              src={selectedAppreciationImg}
              alt="Appreciation Letter Full View"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>
        </div>
      )}

      {/* Image Modal */}
      {showPdfModal && (
        <div
          className="pdf-modal-overlay"
          onClick={() => setShowPdfModal(false)}
        >
          <div
            className="img-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="pdf-modal-close img-modal-close"
              onClick={() => setShowPdfModal(false)}
            >
              ✕
            </button>
            <img
              src="/images/slbpr-images/appreciation_latter.jpg"
              alt="Appreciation Letter"
              style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }}
            />
          </div>
        </div>
      )}

      <div className="a">

        {/* .....................................................about us section.................................................. */}

        <style>{`

/* ================= APPRECIATION CAROUSEL SLIDER STYLES ================= */
.appreciation-carousel-wrapper {
  position: relative;
  max-width: 1300px;
  margin: 0 auto;
}
/* Swipeable Cursor & Touch Gestures */
.appreciation-swipeable {
  cursor: grab;
  user-select: none;
  -webkit-user-select: none;
  touch-action: pan-y;
}

.appreciation-swipeable:active {
  cursor: grabbing;
}

.appreciation-card img {
  pointer-events: none;
  -webkit-user-drag: none;
}

.letter-preview .open-letter-btn {
  pointer-events: auto;
}

/* Slide Arrows */
.slider-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid rgba(226, 232, 240, 0.8);
  color: #0f172a;
  font-size: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  transition: all 0.3s ease;
  line-height: 1;
}

.slider-arrow:hover {
  background: #2563eb;
  color: #ffffff;
  border-color: #2563eb;
  transform: translateY(-50%) scale(1.08);
}

.arrow-left {
  left: -26px;
}

.arrow-right {
  right: -26px;
}

/* Dots & Slide Counter */
.carousel-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 35px;
}

.carousel-dots {
  display: flex;
  gap: 10px;
}

.carousel-dots .dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #cbd5e1;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.carousel-dots .dot.active {
  width: 34px;
  border-radius: 999px;
  background: #2563eb;
}

.slide-counter {
  font-size: 15px;
  font-weight: 700;
  color: #64748b;
}

@media (max-width: 1100px) {
  .arrow-left {
    left: 10px;
  }
  .arrow-right {
    right: 10px;
  }
}
























        .highlights-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

@media (min-width: 768px) {
  .highlights-container {
    flex-direction: row;
    justify-content: center;
  }
}

/* ================= PREMIUM APPRECIATION SECTION ================= */

.appreciation-section {
  position: relative;
  padding: 100px 7%;
  overflow: hidden;
  background:
    radial-gradient(circle at top left, rgba(37,99,235,0.12), transparent 35%),
    radial-gradient(circle at bottom right, rgba(124,58,237,0.12), transparent 35%),
    linear-gradient(135deg, #f8fbff, #eef4ff);
}

/* ================= LETTER SHOWCASE ================= */

.letter-showcase {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.letter-glow {
  position: absolute;
  width: 420px;
  height: 420px;
  background: radial-gradient(
    circle,
    rgba(59,130,246,0.18),
    transparent 70%
  );
  filter: blur(30px);
  z-index: 0;
}

.letter-card {
  position: relative;
  width: 100%;
  max-width: 560px;
  border-radius: 28px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(255,255,255,0.4);
  box-shadow:
    0 25px 80px rgba(15,23,42,0.18),
    0 10px 30px rgba(59,130,246,0.08);
  z-index: 1;
  transition: all 0.4s ease;
}

.letter-card:hover {
  transform: translateY(-10px) scale(1.01);
}

.letter-topbar {
  height: 72px;
  background: linear-gradient(
    135deg,
    #0f172a,
    #172554
  );
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 18px;
}

.dots {
  display: flex;
  gap: 8px;
}

.dots span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255,255,255,0.4);
}

.file-name {
  color: white;
  font-size: 17px;
  font-weight: 600;
}

.letter-preview {
  background: #f8fafc;
  padding: 30px;
  position: relative;
}

.letter-preview img {
  width: 100%;
  border-radius: 14px;
  display: block;
  box-shadow:
    0 20px 50px rgba(15,23,42,0.16);
  transition: transform 0.4s ease;
}

.letter-card:hover .letter-preview img {
  transform: scale(1.02);
}

.letter-overlay {
  position: absolute;
  inset: 0;
  background: rgba(15,23,42,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: 0.35s ease;
}

.letter-card:hover .letter-overlay {
  opacity: 1;
}

.open-letter-btn {
  background: linear-gradient(
    135deg,
    #2563eb,
    #7c3aed
  );
  color: white;
  text-decoration: none;
  padding: 14px 28px;
  border-radius: 14px;
  font-weight: 600;
  font-size: 15px;
  transition: 0.3s ease;
  box-shadow: 0 10px 25px rgba(37,99,235,0.35);
}

.open-letter-btn:hover {
  transform: translateY(-2px);
}

/* PDF/Image Modal */
.pdf-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.pdf-modal-content {
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 900px;
  height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

.img-modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
}

.img-modal-content img {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  display: block;
}

.img-modal-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(0, 0, 0, 0.6) !important;
  border: none;
  color: #fff !important;
  font-size: 18px;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: background 0.2s;
}

.img-modal-close:hover {
  background: rgba(0, 0, 0, 0.9) !important;
}

.pdf-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #0f172a;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
}

.pdf-modal-close {
  background: none;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  line-height: 1;
  padding: 2px 6px;
  border-radius: 4px;
  transition: background 0.2s;
}

.pdf-modal-close:hover {
  background: rgba(255, 255, 255, 0.15);
}

@media (max-width: 600px) {
  .pdf-modal-content {
    width: 100%;
    height: 90vh;
  }
  .img-modal-content img {
    max-width: 95vw;
    max-height: 85vh;
  }
}

.appreciation-bg-glow {
  position: absolute;
  width: 500px;
  height: 500px;
  background: rgba(37,99,235,0.12);
  filter: blur(120px);
  border-radius: 50%;
  top: -150px;
  right: -100px;
}

.appreciation-header {
  text-align: center;
  margin-bottom: 60px;
  position: relative;
  z-index: 2;
}

.appreciation-tag {
  display: inline-block;
  padding: 10px 22px;
  border-radius: 999px;
  background: rgba(37,99,235,0.1);
  color: #2563eb;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 24px;
  border: 1px solid rgba(37,99,235,0.15);
  backdrop-filter: blur(10px);
}

.appreciation-header h2 {
  font-size: 54px;
  line-height: 1.1;
  font-weight: 800;
  margin-bottom: 20px;
  color: #0f172a;
  letter-spacing: -2px;
}

.appreciation-header p {
  max-width: 850px;
  margin: auto;
  color: #475569;
  font-size: 18px;
  line-height: 1.8;
}

.appreciation-card {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: center;

  background: rgba(255,255,255,0.72);
  backdrop-filter: blur(20px);

  border: 1px solid rgba(255,255,255,0.4);

  border-radius: 36px;
  padding: 50px;

  box-shadow:
    0 10px 40px rgba(15,23,42,0.08),
    0 2px 10px rgba(15,23,42,0.05);

  overflow: hidden;
}

// .appreciation-card::before {
//   content: '';
//   position: absolute;
//   inset: 0;
//   border-radius: 36px;
//   padding: 1px;
//   background: linear-gradient(
//     135deg,
//     rgba(37,99,235,0.4),
//     rgba(124,58,237,0.3),
//     rgba(8,145,178,0.3)
//   );
//   -webkit-mask:
//     linear-gradient(#fff 0 0) content-box,
//     linear-gradient(#fff 0 0);
//   -webkit-mask-composite: xor;
// }

.featured-line {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2563eb;
  font-weight: 700;
  margin-bottom: 24px;
}

.pulse-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2563eb;
  box-shadow: 0 0 0 rgba(37,99,235,0.4);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(37,99,235,0.4);
  }
  70% {
    box-shadow: 0 0 0 14px rgba(37,99,235,0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37,99,235,0);
  }
}

.appreciation-content h3 {
  font-size: 52px;
  line-height: 1.1;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 24px;
}

.appreciation-content h3 span {
  background: linear-gradient(90deg, #2563eb, #7c3aed);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.appreciation-content p {
  font-size: 17px;
  line-height: 1.9;
  color: #475569;
  margin-bottom: 28px;
}

.trust-points {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 14px;
  margin-bottom: 35px;
}


.trust-item {
  padding: 10px 16px;
  border-radius: 999px;
  background: rgba(37,99,235,0.08);
  color: #1e293b;
  font-size: 14px;
  font-weight: 600;
}

.appreciation-stats {
  display: flex;
  gap: 18px;
  margin-bottom: 35px;
  flex-wrap: wrap;
}

.stat-box {
  flex: 1;
  min-width: 150px;
  padding: 24px;
  border-radius: 24px;
  background: linear-gradient(
    135deg,
    rgba(255,255,255,0.9),
    rgba(241,245,249,0.9)
  );
  border: 1px solid rgba(37,99,235,0.08);
  transition: 0.3s ease;
}

.stat-box:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 30px rgba(37,99,235,0.12);
}

.stat-value {
  display: block;
  font-size: 36px;
  font-weight: 800;
  color: #2563eb;
  margin-bottom: 10px;
}

.stat-label {
  color: #64748b;
  font-size: 14px;
}

.appreciation-actions {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
}

.view-btn,
.download-btn {
  padding: 16px 28px;
  border-radius: 16px;
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
  transition: 0.35s ease;
}

.view-btn {
  border: none;
  cursor: pointer;
  background: linear-gradient(135deg, #2563eb, #0891b2);
  color: white;
  box-shadow: 0 10px 30px rgba(37,99,235,0.2);
}

.view-btn:hover {
  transform: translateY(-4px);
}

.download-btn {
  border: 1px solid rgba(15,23,42,0.08);
  background: rgba(255,255,255,0.7);
  color: #0f172a;
}

.download-btn:hover {
  background: white;
  transform: translateY(-4px);
}

.pdf-showcase {
  position: relative;
}

.pdf-showcase::before {
  content: '';
  position: absolute;
  inset: 20px;
  background: rgba(37,99,235,0.12);
  filter: blur(40px);
  z-index: 0;
}

.pdf-topbar {
  height: 55px;
  background: #0f172a;
  border-radius: 22px 22px 0 0;
  display: flex;
  align-items: center;
  padding: 0 20px;
  gap: 18px;
}

.pdf-dots {
  display: flex;
  gap: 8px;
}

.pdf-dots span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #64748b;
}

.pdf-title {
  color: white;
  font-size: 14px;
  font-weight: 600;
}

.pdf-frame {
  position: relative;
  z-index: 1;
  overflow: hidden;
  border-radius: 0 0 24px 24px;
  border: 1px solid rgba(15,23,42,0.08);
  background: white;
}

.pdf-frame iframe {
  width: 100%;
  height: 620px;
  border: none;
}

/* Responsive */

@media(max-width: 1100px) {
  .appreciation-card {
    grid-template-columns: 1fr;
  }

  .appreciation-content h3 {
    font-size: 42px;
  }
}

@media(max-width: 768px) {

  .appreciation-section {
    padding: 70px 5%;
  }

  .appreciation-header h2 {
    font-size: 38px;
  }

  .appreciation-content h3 {
    font-size: 34px;
  }

  .appreciation-card {
    padding: 30px;
  }

  .pdf-frame iframe {
    height: 500px;
  }
}
.highlight-card {
  background: linear-gradient(135deg,rgba(90, 134, 216, 0.6),rgba(90, 184, 213, 0.69));
  backdrop-filter: blur(8px);
  color: white;
  padding: 25px;
  border-radius: 16px;
  flex: 1;
  margin: 10px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.highlight-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.3);
}

.products-card {
  background: linear-gradient(135deg,rgba(220, 230, 223, 0.64),rgba(83, 163, 162, 0.66));
    backdrop-filter: blur(8px);

}

.highlight-card .icon {
  font-size: 40px;
  margin-bottom: 15px;
}

.highlight-card h2 {
  font-size: 20px;
  margin-bottom: 10px;
}

.highlight-card p {
  font-size: 14px;
  margin-bottom: 20px;
}

.highlight-card button {
  background: white;
  color: black;
  border: none;
  padding: 10px 20px;
  border-radius: 25px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s ease;
}

.highlight-card button:hover {
  background: #f0f0f0;
}

/* ================= Appreciation Section ================= */

.appreciation-section {
  // margin: 40px 0;
}

.appreciation-header {
  text-align: center;
  margin-bottom: 30px;
}

.appreciation-tag {
  display: inline-block;
  padding: 8px 18px;
  background: rgba(37, 99, 235, 0.1);
  color: #2563eb;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 16px;
}

.appreciation-header h2 {
  font-size: 36px;
  font-weight: 800;
  color: var(--text-primary);
  margin-bottom: 12px;
  line-height: 1.2;
}

.appreciation-header p {
  max-width: 780px;
  margin: auto;
  color: var(--text-secondary);
  font-size: 16px;
  line-height: 1.7;
}

.appreciation-card {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 28px;
  background: linear-gradient(
    135deg,
    rgba(255,255,255,0.95),
    rgba(248,250,252,0.95)
  );
  border: 1px solid var(--border-color);
  border-radius: 28px;
  padding: 32px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.08);
  position: relative;
}

[data-theme="dark"] .appreciation-card {
  background: linear-gradient(
    135deg,
    rgba(15,23,42,0.95),
    rgba(30,41,59,0.95)
  );
}

.appreciation-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(
    90deg,
    #2563eb,
    #0891b2,
    #7c3aed
  );
}

.appreciation-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.appreciation-badge {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 10px 16px;
  border-radius: 999px;
  background: rgba(16, 185, 129, 0.12);
  color: #059669;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 20px;
}

.appreciation-content h3 {
  font-size: 30px;
  font-weight: 800;
  margin-bottom: 16px;
  color: var(--text-primary);
  line-height: 1.2;
}

.appreciation-content p {
  color: var(--text-secondary);
  font-size: 15px;
  line-height: 1.8;
  margin-bottom: 28px;
}

.appreciation-stats {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 28px;
}

.stat-box {
  min-width: 140px;
  padding: 18px;
  border-radius: 18px;
  background: rgba(37, 99, 235, 0.06);
  border: 1px solid rgba(37, 99, 235, 0.1);
}

.stat-value {
  display: block;
  font-size: 24px;
  font-weight: 800;
  color: #2563eb;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 13px;
  color: var(--text-secondary);
}

.appreciation-actions {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}

.view-btn,
.download-btn {
  padding: 14px 24px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: 0.3s ease;
  text-decoration: none;
}

.view-btn {
  background: linear-gradient(135deg, #2563eb, #0891b2);
  color: white;
}

.view-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.25);
}

.download-btn {
  background: transparent;
  border: 1px solid var(--border-color);
  color: var(--text-primary);
}

.download-btn:hover {
  background: rgba(37, 99, 235, 0.06);
  border-color: #2563eb;
  color: #2563eb;
}

.pdf-preview {
  position: relative;
  min-height: 500px;
  border-radius: 22px;
  overflow: hidden;
  border: 1px solid var(--border-color);
  background: #fff;
}

.pdf-preview iframe {
  width: 100%;
  height: 100%;
  min-height: 500px;
  border: none;
}

/* Responsive */

@media (max-width: 1024px) {
  .appreciation-card {
    grid-template-columns: 1fr;
  }

  .pdf-preview {
    min-height: 420px;
  }
}

@media (max-width: 768px) {
  .appreciation-header h2 {
    font-size: 28px;
  }

  .appreciation-card {
    padding: 24px;
  }

  .appreciation-content h3 {
    font-size: 24px;
  }

  .appreciation-stats {
    flex-direction: column;
  }

  .stat-box {
    width: 100%;
  }
}
          .about-section {
            overflow: hidden;
            padding-bottom: 70px;
            display: "flex";
            width: 100%;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            background: rgb(255, 255, 255);
            text-align: center;
          }
          .cccontainer {
            max-width: 1500px;
            margin: 0 auto;
            // background: green;
            padding: 0;
          }
          // .heading-cccontainer {
          //   margin-bottom: 30px;
          // }
          .title {
            font-size: 32px;
            font-weight: bold;
            color: #333;
            margin-top: 0px;
          }
          .underline {
            width: 80px;
            height: 4px;
            background: #007bff;
            margin: 8px auto;
          }
          .content-griiid {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 30px;
            position: relative;
            left: 100px:
            // margin: "0px";
             // background: #007bff;

            padding: "0px";
            
            flex-wrap: wrap;
          }
          .imagee {
            min-width: 45%;
            border-radius: 8px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          }
          .text-content {
            width: 50%;
            // position: relative;
            // right: 20px;
            height: 100%;
            // background: blue;
            text-align: left;
            z-index: 2;
          }
          .subtitle {
            font-size: 25px;
            color: #007bff;
            margin-bottom: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .descriptionnn {
            font-size: 16px;
            // width: 100%;
            color: #555;
            line-height: 1.6;
            // margin-right: 20px;
            padding: 10px;
            margin-bottom: 10px;
          }
          .button {
            background: #007bff;
            color: #fff;
            padding: 10px 20px;
            font-size: 16px;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            transition: background 0.3s;
          }
          .button:hover {
            background: #0056b3;
          }
          @media (max-width: 768px) {
            .content-grid {
              flex-direction: column;
              text-align: center;
            }
            .image {
              width: 90%;
            }
            .text-content {
              width: 100%;
            }
          }

          /* Background and container */
/* .hsection {
  background: linear-gradient(to right,rgba(0, 225, 255, 0.955), #2a5298);
  padding: 50px 0;
  margin-top: 60px;
  color: white;
} */


.video-container {
  position: fixed;
  top: 0;
  /* background-color: rgb(155, 188, 189); */
  // background: linear-gradient(rgba(53, 83, 255, 0.86));

  left: 0;
  width: 110vw;
  height: 100%;
  overflow: hidden;
  z-index: -1;
}

/* .video-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
} */


.hsection {
  z-index: 1;
  padding-top: 105px;
  padding-bottom: 30px;
  color: white;
  max-width: 1600px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

.hcontainer {
  max-width: 1500px;
  margin: auto;
  /* padding: 10px; */
}


/* Grid Layout */
.hcontent-grid {
  display: flex;
  align-items: center;
  // margin-bottom: 35px;
  /* margin-top: 85px; */
  justify-content: space-between;
  gap: 20px;
  /* background-color: red; */
  
  flex-direction: column;
}

.aaaaaa{
  /* background-color: red; */
  height: auto;
  min-height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 10px;
}

/* Text Section */
.htitle {
  font-size: clamp(2.2rem, 3.8vw, 3.6rem);
  line-height: 1.25;
  z-index: 10;
  font-weight: bold;
  margin-bottom: 12px;
}

.hhighlight {
  color: rgba(14, 187, 255, 0.788);
  /* text-shadow: 2px 2px 8px rgb(255, 255, 255); */

}

.hsubtitle {
  font-size: 1.3rem;
  margin-top: 10px;
  width: 85%;
  z-index: 10;
  color: white;
  // padding: 150px;
  opacity: 0.9;
}

/* Buttons */
.hbutton-group {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.hbutton {
  /* background: #ffcc00;
  color: #ffffff; */
  background-color: white;
  color: black;
  padding: 12px 24px;
  z-index: 10;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  transition: 0.3s;
  font-size: 15px;
  cursor: pointer;
}

.hbutton:hover {
  background: #53c8d3;
  transform: scale(1.05);
}

/* Social Icons */
.hsocial-icons {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.hsocial-icons .icon {
  font-size: 3rem;
  color: rgb(255, 255, 255);
  transition: 0.3s;
}


.hsocial-icons .icon:hover {
  transform: scale(1.2);
  color: #ffcc00;
}

/* Image Section */
.himage-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
}

.parta{
  /* background-color: red; */
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  cursor: pointer;
}


.ddescripttion{
  height: 30px;
  z-index: 10;
  display: flex;
  color: rgb(255, 255, 255);
  width: 300px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: rgba(14, 187, 255, 0.788);
}
.ddescripttion:hover{
  background-color: #53c8d3;
  transform: scale(1.05);
  transition: 0.3s;
}

.himage {
  min-width: 350px;
  height: 210px;
  border-radius: 12px;
  /* margin-bottom: 60px; */
  transition: 0.3s;
}

.himage:hover {
  transform: scale(1.05);
  box-shadow: 0px 4px 15px rgba(255, 255, 255, 0.3);
}

/* 📱 Responsive Design */
@media screen and (max-width: 768px) {
  .hcontent-grid {
    flex-direction: column;
    text-align: center;
    margin-top: 15px;
  }

  .hsection{
    padding-top: 85px;
    margin-top: 0px;
  }

  .htitle {
    font-size: 2.5rem;
  }

  .hsubtitle {
    font-size: 1rem;
    margin: 10px auto;
  }

  .hbutton-group {
    justify-content: center;
  }

  .himage-container {
    width: 90%;
    margin: auto;
  }

  .aaaaaa{
    /* background-color: red; */
    width: 100%;
    height: 100%;
  }

  .image-grid {
    grid-template-columns: 1fr;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .hbutton {
    width: 100%;
    padding: 14px;
  }

  .hsocial-icons {
    justify-content: center;
  }
}

/* Extra Small Devices */
@media screen and (max-width: 480px) {
  .htitle {
    font-size: 2rem;
  }

  .aaaaaa{
    /* background-color: red; */
    width: 100%;
    height: 100%;
  }
  .hsubtitle {
    font-size: 0.9rem;
  }
  .hsection{
    margin-top: 0px;
  }

  .hcontent-grid {
    /* margin-bottom: 195px;
    margin-top: 180px; */
  }

  .hbutton {
    font-size: 1rem;
  }

}





/* ............................................................................................... */
.happy-clients-section {
  position: relative;
  overflow: hidden;
   background-color: rgb(255, 255, 255);
  padding: 10px 0;
}

.background-blur {
  position: absolute;
  top: -120px;
  left: 50%;
  width: 110vw;
  height: 284px;
  transform: translateX(-50%);
  /* border-radius: 50%; */
  /* background: linear-gradient(to right,#87fff5, #86c6e0); */
  background-color: transparent;
  filter: blur(48px);
}

.container {
  position: relative;
  margin: 0 auto;
  /* padding: 0 16px; */
  /* max-width: 1300px; */
}

.headerrer{
  text-align: center;
}

.text-center {
  text-align: center;
  z-index: 2;
}

.heading {
  margin-bottom: 16px;
  font-size: 2.5rem;
  font-weight: bold;
  color: #1e293b;
}

.gradient-text {
  background: linear-gradient(to right, #2770ab, #2ed0ec);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.description {
  max-width: 640px;
  margin: 0 auto;
  font-size: 1.125rem;
  color: #475569;
  // padding-bottom: 30px;
}

.contaaaainer{
  background-color: red;
  padding: 0;
  margin: 0;
  width: auto;
}

/* ............................................................................................... */

.stats-section {
  padding: 60px 40px;
  background: transparent;
  backdrop-filter: blur(6px);
}

.containerrr {
  max-width: 900px;
  margin: 0 auto;
}

.stats-grid {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
}

.stat-card {
  background: #ffffff;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  padding: 32px 50px;
  text-align: center;
  flex: 1;
  max-width: 280px;
}

.stat-logo-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 14px;
  height: 44px;
}

.stat-logo {
  height: 36px;
  width: auto;
  object-fit: contain;
}

.stats-divider {
  width: 3px;
  height: 160px;
  background: linear-gradient(to bottom, #00bcd4, #2563eb);
  border-radius: 4px;
  flex-shrink: 0;
}

.stat-stars {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-bottom: 12px;
}

.stat-star {
  font-size: 1.8rem;
  color: #f5a623;
}

.stat-label {
  color: #1a1a2e;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
}

.stat-label-divider {
  width: 60px;
  height: 1.5px;
  background: #e0e0e0;
  margin: 0 auto 10px;
  border-radius: 2px;
}

.stat-sub {
  color: #0ea5e9;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
}

@media (max-width: 600px) {
  .stats-grid {
    flex-direction: column;
  }
  .stats-divider {
    width: 120px;
    height: 3px;
  }
}


/* ================= MODERN TESTIMONIALS SECTION ================= */
.testimonials-section {
  padding: 90px 20px;
  z-index: 2;
  position: relative;
  background:
    radial-gradient(circle at 15% 20%, rgba(37, 99, 235, 0.05), transparent 45%),
    radial-gradient(circle at 85% 80%, rgba(14, 165, 233, 0.05), transparent 45%),
    linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
}

.containerrrrr {
  max-width: 1080px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

/* Header */
.testimonial-section-header {
  text-align: center;
  margin-bottom: 40px;
}

.testimonial-tag {
  display: inline-block;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: #2563eb;
  background: rgba(37, 99, 235, 0.08);
  border: 1px solid rgba(37, 99, 235, 0.18);
  padding: 6px 16px;
  border-radius: 999px;
  margin-bottom: 14px;
}

.testimonial-heading {
  font-size: clamp(28px, 3.2vw, 40px);
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.5px;
  margin: 0 0 12px;
}

.testimonial-subheading {
  font-size: clamp(14px, 1.2vw, 16px);
  color: #64748b;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Card Box */
.testimonial-box {
  background: #ffffff;
  padding: 44px 50px 36px;
  border-radius: 28px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow:
    0 25px 60px -15px rgba(15, 23, 42, 0.08),
    0 10px 25px -5px rgba(37, 99, 235, 0.04);
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.testimonial-box:hover {
  box-shadow:
    0 30px 70px -15px rgba(15, 23, 42, 0.12),
    0 12px 30px -5px rgba(37, 99, 235, 0.06);
}



/* Top Bar: Counter & Buttons */
.testimonial-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  position: relative;
  z-index: 5;
}

.testimonial-counter {
  font-size: 13.5px;
  font-weight: 600;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 5px 12px;
  border-radius: 20px;
}

.counter-current {
  color: #2563eb;
  font-weight: 700;
}

.counter-separator {
  color: #cbd5e1;
}

.testimonial-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.testimonial-nav-btn {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  color: #334155;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
}

.testimonial-nav-btn:hover {
  background: #2563eb;
  border-color: #2563eb;
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.25);
}

.testimonial-nav-btn:active {
  transform: translateY(0);
}

/* Content Area */
.testimonial-content {
  min-height: 270px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
}

.testimonial-card {
  width: 100%;
}

/* Client Info */
.client-info {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.client-avatar-wrapper {
  position: relative;
  width: 88px;
  height: 88px;
  margin: 0 auto;
}

.client-image {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  object-fit: cover;
  border: 3.5px solid #ffffff;
  outline: 2.5px solid #bfdbfe;
  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.2);
}

.client-avatar-badge {
  position: absolute;
  bottom: 0px;
  right: -2px;
  width: 24px;
  height: 24px;
  background: #2563eb;
  color: #ffffff;
  border-radius: 50%;
  border: 2px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.client-name {
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  margin: 14px 0 3px;
  letter-spacing: -0.2px;
}

.client-position {
  font-size: 14.5px;
  font-weight: 500;
  color: #2563eb;
  margin: 0 0 10px;
}

.rating {
  display: inline-flex;
  gap: 3px;
  padding: 4px 12px;
  background: #fffbeb;
  border: 1px solid #fef3c7;
  border-radius: 999px;
}

.rating .star {
  font-size: 15px;
  color: #cbd5e1;
}

.rating .star.filled {
  color: #f59e0b;
}

/* Quote Text */
.testimonial-text {
  text-align: center;
  margin-top: 18px;
}

.quote-text {
  font-size: clamp(16px, 1.35vw, 19px);
  line-height: 1.7;
  color: #334155;
  font-style: italic;
  max-width: 820px;
  margin: 0 auto 20px;
}

/* Tags & Verified Pill */
.testimonial-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.tag-pill {
  font-size: 12.5px;
  font-weight: 500;
  color: #475569;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 4px 12px;
  border-radius: 999px;
  transition: all 0.2s ease;
}

.tag-pill:hover {
  background: #e2e8f0;
  color: #1e293b;
}

.verified-pill {
  font-size: 12.5px;
  font-weight: 600;
  color: #059669;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  padding: 4px 12px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

/* Make “What our client’s say” cards equal height */
.scroll-card .testimonial {
  flex: 1;
  margin: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

/* Dots */
.testimonial-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 30px;
  position: relative;
  z-index: 5;
}

.dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #cbd5e1;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.dot:hover {
  background: #94a3b8;
}

.dot.active {
  width: 28px;
  height: 9px;
  border-radius: 999px;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .testimonials-section {
    padding: 60px 16px;
  }
  .testimonial-box {
    padding: 30px 20px 26px;
    border-radius: 20px;
  }
  .testimonial-content {
    min-height: 320px;
  }
  .quote-text {
    font-size: 15px;
    line-height: 1.65;
  }
  .client-image,
  .client-avatar-wrapper {
    width: 76px;
    height: 76px;
  }
}

/* /////////////////////////////////////////////////////////////////////////////////// */
/* SuccessStories.css */
.success-section {
  padding: 64px 0;
  background-color: #f8f9fa;
  text-align: center;
  z-index: 2;
}

.containner {
  /* max-width: 1200px; */
  width: 100vw;
  height: 95vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 80px;
  /* margin: 0 auto; */
  /* padding: 0 16px; */
}

.sectionnn-title {
  /* margin-bottom: 48px; */
  font-size: 40px;
  margin-top: 0;
  font-weight: bold;
  color: #fffafa;
}

/* .grid-container {
  display: grid;
  width: 95vw;
  gap: 24px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
} */

/* .card {
  background: white;
  z-index: 2;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
} */

.success-section {
  width: 100%;
  overflow: hidden;
  padding: 40px 0;
  position: relative;
  z-index: 2;
}

.grid-container {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 20px;
  padding: 20px;
  scroll-behavior: smooth;
  max-width: 100%;
}

.card {
  flex: 0 0 300px; /* Adjust width */
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;.
  height: 100px;
  text-align: left;
  transition: transform 0.2s ease-in-out;
}

.grid-container::-webkit-scrollbar {
  height: 6px;
}

.grid-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.grid-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.grid-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}


.card:hover {
  transform: translateY(-5px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.profile {
  display: flex;
  align-items: center;
  gap: 5px;
}

.profile-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}

.profile-name {
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin: 0;
}

.profile-position {
  font-size: 14px;
  color: #666;
  margin: 0;
  // width: 100px;
  overflow: hidden; 
}

.stars {
  display: flex;
  gap: 4px;
}

.star-icon {
  color: #fbbc05;
}

.testimonial {
  color: #555;
  font-size: 14px;
  // overflow: hidden;  
  // background: red;
  // width:100%;
  // background: red;
  margin-bottom: 16px;
}

.read-more {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: #007bff;
  cursor: pointer;
}

.read-more .arrow-icon {
  margin-left: 6px;
  transition: transform 0.2s ease-in-out;
}

.read-more:hover .arrow-icon {
  transform: translateX(4px);
}


/* //////////////////////////////////////////////////////////////////////////////// */
.team-section {
  background-color: rgb(255, 255, 255);
  z-index: 2;
  position: relative;
}

.contaiiiner {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #1e293b;
  margin-bottom: 16px;
}

.description {
  /* max-width: 600px; */
  margin: 0 auto;
  font-size: 1.125rem;
  color: #475569;
}

/* .team-grid {
  display: grid;
  gap: 32px;
  width: 100vw;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  margin-top: 32px;
} */

/* .team-member {
  text-align: center;
  padding: 10px;
} */

.team-grid {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 40px;
  padding-bottom: 20px;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

.team-member {
  flex: 0 0 auto;
  background-size: cover;
  background-position: center;
  width: 300px; /* Adjust width as needed */
  // background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 0px;
  text-align: center;
}

.team-grid::-webkit-scrollbar {
  height: 8px;
}

.team-grid::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.team-grid::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.team-grid::-webkit-scrollbar-thumb:hover {
  background: #555;
}


.image-container {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
}

.team-image {
  min-width: 100%;
  height: 300px;
  z-index: 2;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.image-container:hover .team-image {
  transform: scale(1.1);
}

.overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(30, 41, 59, 0.9), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-container:hover .overlay {
  opacity: 1;
}

.social-icons {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateY(100%);
  display: flex;
  color: white;
  gap: 16px;
  padding: 16px;
  transition: transform 0.3s ease;
}


.image-container:hover .social-icons {
  transform: translateX(-50%) translateY(0);
  color: white;
}

.iccon {
  width: 100%;
  height: 25px;
  padding: 5px;
  font-size: 10px;
  background-color: red;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  transition: background-color 0.3s ease;
}

.iccon:hover {
  background-color: #3b82f6;
}

.member-name {
  font-size: 1.25rem;
  font-weight: bold;
  color: #1e293b;
  margin-top: 16px;
}

.position {
  color: #3b82f6;
  margin-bottom: 8px;
}


.scroll-wrapper {
  display: flex;
  overflow-x: auto;
  gap: 20px;
  padding: 20px 0;
  scroll-behavior: smooth;
}

.scroll-wrapper::-webkit-scrollbar {
  height: 8px;
}

.scroll-wrapper:hover {
  /* nothing needed unless you want to do something special */
}
.css-title{
  width: 100%;
  /* background-color: red; */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.bio {
  color: #475569;
  font-size: 16px;
}
.footer {
  position: relative;
  z-index: 2;
  background: linear-gradient(135deg, #07111f 0%, #0f172a 50%, #082f49 100%);
  color: #f8fafc;
  padding: 80px 40px 30px;
  font-family: "Arial", sans-serif;
  overflow: hidden;
}

.footer::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(148, 163, 184, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.06) 1px, transparent 1px);
  background-size: 42px 42px;
  pointer-events: none;
}

.footer::after {
  content: "";
  position: absolute;
  width: 420px;
  height: 420px;
  right: -140px;
  top: -180px;
  background: radial-gradient(circle, rgba(56, 189, 248, 0.18), transparent 68%);
  pointer-events: none;
}

.footer-container {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 2fr 1fr 1.2fr 1.2fr;
  gap: 48px;
  align-items: start;
  padding-bottom: 48px;
}

.footer-section {
  min-width: 0;
}

/* Brand block */
.footer-brand {
  padding: 28px 32px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0 16px 40px rgba(2, 6, 23, 0.2);
  position: relative;
}

.footer-brand::before {
  content: "";
  position: absolute;
  left: 0;
  top: 24px;
  bottom: 24px;
  width: 3px;
  border-radius: 999px;
  background: linear-gradient(to bottom, #38bdf8, #2563eb);
}
.yy {
  margin-bottom: 18px;
}

.footer-logo-img {
  height: 52px;
  width: 200px;
  background-image: url("/images/log.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left center;
  filter: brightness(0) saturate(100%) invert(27%) sepia(98%) saturate(1200%) hue-rotate(210deg) brightness(95%);
}

.footer-brand p {
  color: #cbd5e1;
  font-size: 14.5px;
  line-height: 1.85;
  margin: 0 0 12px;
}

.footer-brand p:last-child {
  margin-bottom: 0;
}

/* Headings */
.footer-section h3,
.footer-section h4 {
  margin: 0 0 20px;
  color: #ffffff;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.footer-section h4 {
  position: relative;
  padding-bottom: 12px;
}

.footer-section h4::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 36px;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(to right, #38bdf8, #2563eb);
}

/* Links */
.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-section li {
  line-height: 1;
}

.footer-section p,
.footer-section li,
.footer-section a {
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.6;
}

.footer-section a {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  transition: color 0.2s ease, transform 0.2s ease;
}

.footer-section a::before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(56, 189, 248, 0.6);
  flex-shrink: 0;
  transition: transform 0.2s ease, background 0.2s ease;
}

.footer-section a:hover {
  color: #ffffff;
  transform: translateX(4px);
}

.footer-section a:hover::before {
  background: #38bdf8;
  transform: scale(1.4);
}

/* Contact bar */
.footer-contact-bar {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto 32px;
}

.footer-contact-bar h4 {
  color: #ffffff;
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 16px;
}

.footer-contact-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.footer-contact-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 18px 24px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}

.footer-contact-row strong {
  color: #e2e8f0;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.footer-contact-row span {
  color: #7dd3fc;
  font-size: 15px;
  font-weight: 500;
  word-break: break-word;
}

.footer-contact-row:hover {
  transform: translateY(-3px);
  border-color: #3b82f6;
  background: rgba(59, 130, 246, 0.1);
}

/* Divider & bottom */
.footer-hr {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto 20px;
  border: 0;
  border-top: 1px solid rgba(148, 163, 184, 0.18);
}

.footer-bottom {
  position: relative;
  z-index: 1;
  text-align: center;
  font-size: 13px;
  color: #64748b;
  margin: 0;
  padding-bottom: 8px;
}

/* Responsive */
@media (max-width: 1100px) {
  .footer-container {
    grid-template-columns: 1fr 1fr;
    gap: 36px;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 56px 20px 24px;
  }
  .footer-container {
    grid-template-columns: 1fr;
    gap: 28px;
  }
  .footer-brand {
    padding: 22px 20px;
  }
  .footer-contact-list {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .footer-contact-list {
    grid-template-columns: 1fr;
  }
}

/* ////////////////////////////////////////////////////////////// */
.containerrrrrr{
  background-color: white;
  /* padding: 20px; */
  padding-top: 20px;
  padding-bottom: 50px;
  padding-left: 20px;
  padding-right: 20px;
  height: 100%;
  overflow: hidden;
  backdrop-filter: blur(5px);
}

.headinggg {
  margin-bottom: 2rem;
  text-align: center;
  font-size: 1.9rem;
  font-weight: bold;
  color:rgb(10, 10, 10);
}

.logos-containerrr {
  display: flex;
  // flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 2rem;
}

.logo-wrapperrr {
  position: relative;
  height: 200px;
  // background:rgb(216, 216, 216);
  display: flex;
  justify-content: center;
  align-items: center;
  // background-size: cover;
  // background-position: center;
  width: 250px;
  /* filter: grayscale(100%); */
  transition: all 0.3s ease-in-out;
  flex-shrink: 0;
}

.logo-wrapper:hover {
  filter: grayscale(0%);
}

.logo-imageee {
  height: 100%;
  max-width: 250px;
  border-radius: 5px;
  // width: 100%;
  // padding: 3px;
  object-fit: contain;
  background-color: rgba(255, 255, 255, 0.84);
  backdrop-filter: blur(9px);
}















/* contact page css here */
/* Page Container */
.page-container {
  /* min-height: 20vh; */
  width: 100vw;
  /* display: flex; */
  /* flex-direction: column; */
  /* justify-content: center; */
  /* align-items: center; */
  /* background: green; */
  /* background: linear-gradient(135deg, var(--blue-50), var(--purple-50)); */
}

/* Hero Banner */
.hero-banner {
  height: 40vh;
  background-image: url('https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1920&q=80');
  background-size: cover;
  background-position: center;
  position: relative;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(4px);
}

.hero-content {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-text {
  text-align: center;
}

.hero-text h1 {
  font-size: 3.75rem;
  font-weight: bold;
  color: var(--gray-800);
  margin-bottom: 1rem;
}

.hero-text p {
  font-size: 1.25rem;
  color: var(--gray-600);
  max-width: 42rem;
  margin: 0 auto;
  padding: 0 1rem;
}

.content-grid {
  display: grid;
  /* background-color: red; */
  /* margin-top: 8rem;
  margin-left: 4%; */
  width: 100vw;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-top: 10px;
  margin-bottom: 10px;
  height: 100%;
  /* margin-bottom: 4rem; */
}

@media (min-width: 768px) {
  .content-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Contact Form */
.contact-form-container {
  background: white;
  border-radius: 1rem;
  padding: 1rem;
  margin-left: 35px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}


.form-header {
  margin-bottom: 2rem;
}

.form-header h2 {
  font-size: 1.875rem;
  font-weight: bold;
  color: var(--gray-800);
  margin-bottom: 0.5rem;
}

.form-header p {
  color: var(--gray-600);
}

.form-groupp {
  margin-bottom: 1.5rem;
}

.form-groupp label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--gray-700);
  margin-bottom: 0.5rem;
}

.form-groupp input,
.form-groupp textarea {
  width: 90%;
  /* padding: 0.75rem 1rem; */
  border-radius: 0.5rem;
  /* background: var(--gray-50); */
  /* border: 1px solid var(--gray-200); */
  border: solid 1px black;
  transition: all 0.3s ease;
}

.form-groupp input:focus,
.form-groupp textarea:focus {
  outline: none;
  border-color: var(--blue-500);
  box-shadow: 0 0 0 3px var(--blue-100);
}

.form-groupp textarea {
  height: 8rem;
  resize: vertical;
}

.submit-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: var(--blue-600);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.3);
}

.submit-button:hover {
  background: var(--blue-700);
}

.button-icon {
  width: 1.25rem;
  height: 1.25rem;
  transition: transform 0.3s ease;
}

.submit-button:hover .button-icon {
  transform: translateX(4px);
}

.success-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: var(--green-600);
  background: var(--green-100);
  padding: 0.75rem;
  border-radius: 0.5rem;
  margin-top: 1rem;
  animation: bounce 1s infinite;
}

/* Contact Information */
.contactt-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.info-card {
  background: white;
  border-radius: 1rem;
  padding: 3rem;
  margin-right: 40px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: flex;
  align-items: flex-start;
  gap: 8.5rem;
}

.info-card:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.icon-container {
  /* padding: 1rem; */
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  
  border-radius: 0.75rem;
  transition: background-color 0.3s ease;
}

.icon-container svg {
  width: 1.5rem;
  height: 1.5rem;
}

.blue {
  background: var(--blue-100);
  color: var(--blue-600);
}

.purple {
  background: var(--purple-100);
  color: var(--purple-600);
}

.green {
  background: var(--green-100);
  color: var(--green-600);
}

.orange {
  background: var(--orange-100);
  color: var(--orange-600);
}

.info-content{
  /* background-color: red; */
  display: flex;
  height: 100px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.info-content h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 0.5rem;
}

.info-content p {
  color: var(--gray-600);
  margin-bottom: 0.5rem;
}

.highlight {
  font-weight: 500;
}
.our-services-section {
  /* background: linear-gradient(to bottom, #3a1c71, #d76d77 80%); */
  background: transparent;
  backdrop-filter: blur(6px);
  color: white;
  padding: 10px 20px;
  position: relative;
  z-index: 2;
  text-align: center;
}

.section-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 10px;
}

.section-subtitle {
  max-width: 900px;
  margin: 0 auto 40px;
  font-size: 19px;
  color: #e0e0e0;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.service-card {
  background: white;
  color: black;
  border-radius: 16px;
  padding: 40px 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
}

.service-card:hover {
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);
}

.service-icon {
  font-size: 32px;
  color: #d63384;
  margin-bottom: 15px;
}

.service-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.service-description {
  font-size: 14px;
  color: #555;
}

.ctacta-box {
  background: linear-gradient( #ffffff3a);
  border-radius: 16px;
  padding: 40px 20px;
  max-width: 700px;
  margin: 0 auto;
}

.ctacta-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
}

.ctacta-description {
  font-size: 14px;
  color: white;
  margin-bottom: 20px;
}

.ctacta-button {
  background: white;
  color: #6f42c1;
  font-weight: 600;
  padding: 10px 25px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cta-button:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

/* Animations */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideRight {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideLeft {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.animate-slide-down {
  animation: slideDown 0.5s ease-out;
}

.animate-slide-up {
  animation: slideUp 0.5s ease-out;
}

.animate-slide-right {
  animation: slideRight 0.5s ease-out;
}

.animate-slide-left {
  animation: slideLeft 0.5s ease-out;
}

.animate-fade-in {
  animation: fadeIn 1s ease-out;
}








/* Main container.... styles......................................... */
.scontainer {
  overflow: hidden;
  /* min-height: 100vh; */
  height: 30vh;
  /* background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #1a1a1a 100%); */
}

.slider-container {
  height: 35vh;
  width: 100%;
  backdrop-filter: blur(18px);
  overflow: hidden;
  position: relative;
}

/* Gradient overlays */
.gradient-left,
.gradient-right {
  position: absolute;
  top: 0;
  height: 30vh;
  width: 128px;
  z-index: 10;
}

.gradient-left {
  left: 0;
  background: linear-gradient(90deg, #1a1a1a 0%, transparent 100%);
}

.gradient-right {
  right: 0;
  background: linear-gradient(-90deg, #1a1a1a 0%, transparent 100%);
}

/* Slider track */
// .slider-track {
//   position: absolute;
//   display: flex;
//   /* background-color: white; */
//   gap: 48px;
//   transition: transform 0.3s ease;
// }

/* Logo container */
.slogo-container {
  width: 300px;
  height: 25vh;
  flex-shrink: 0;
  border-radius: 12px;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(8px);
  padding: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.logo-container:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: scale(1.05);
}

/* Logo image */
.slogo-image {
    width: 70%;
    height: 70%;
  object-fit: contain;
  filter: brightness(0.9) contrast(1.1);
  mix-blend-mode: luminosity;
  transition: all 0.3s ease;
}

.logo-image:hover {
  filter: brightness(1.1) contrast(1.1);
}

p{
  z-index: 5;
}

h1{
  z-index: 5;
}

h2{
  z-index: 5;
}

h3{
  z-index: 5;
}
h4{
  z-index: 5;
}
h5{
  z-index: 5;
}



/* logo slides company, css */
.slider-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 2;
  white-space: nowrap;
  position: relative;
}

.slider-track {
  display: flex;
  gap: 40px;
  width: max-content;
  z-index: 2;
  animation: scroll-partner 35s linear infinite;
}

.slider-track:hover {
  animation-play-state: paused;
}

.slider-image {
  width: 300px;
  z-index: 2;
  height: 100px;
  padding: 20px;
  // background-color: rgba(255, 255, 255, 0.322);
  // backdrop-filter: blur(6px);
  padding-right: 10px;
  padding-left: 10px;
  border-radius: 10px;
  flex-shrink: 0;
}

@keyframes scroll-partner {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

















/* case study section */

.card-slideerr-container {
  width: 100%;
  padding: 24px 0 62px;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  z-index: 2;
  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
}

.cardds-slider-track {
  display: flex;
  width: max-content;
  gap: 18px;
  animation: slide 48s linear infinite;
  position: relative;
  z-index: 2;
}

.card-slideerr-container:hover .cardds-slider-track,
.cardds-slider-track:hover {
  animation-play-state: paused;
}

/* Card base */
.carddr {
  width: 230px;
  min-height: 220px;
  background: #ffffff;
  border: 1px solid rgba(203, 213, 225, 0.7);
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);
  color: #0f172a;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 20px;
  border-radius: 14px;
  text-align: left;
  white-space: normal;
  transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease, border-color 0.25s ease;
  cursor: pointer;
}

.carddr:hover {
  transform: translateY(-5px);
  background: #1e3a8a;
  border-color: #1e3a8a;
  box-shadow: 0 12px 32px rgba(30, 58, 138, 0.35);
}

.carddr:hover .carddr-icon {
  background: rgba(255, 255, 255, 0.15);
}

.carddr:hover .carddr-label {
  color: rgba(147, 197, 253, 1);
}

.carddr:hover .carddr-title {
  color: #ffffff;
}

.carddr:hover .carddr-link {
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.35);
}

/* Highlighted card — dark navy */
.carddr--highlight {
  background: #1e3a8a;
  border-color: #1e3a8a;
  color: #ffffff;
  box-shadow: 0 8px 32px rgba(30, 58, 138, 0.35);
}

.carddr--highlight .carddr-icon {
  background: rgba(255, 255, 255, 0.15);
}

.carddr--highlight .carddr-icon span {
  filter: brightness(10);
}

.carddr--highlight .carddr-label {
  color: rgba(147, 197, 253, 1);
}

.carddr--highlight .carddr-title {
  color: #ffffff;
}

.carddr--highlight .carddr-link {
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.35);
}

.carddr--highlight .carddr-link:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* Icon circle */
.carddr-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(37, 99, 235, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-bottom: 4px;
  flex-shrink: 0;
}

/* "CASE STUDY" label */
.carddr-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #2563eb;
  margin: 0;
  transition: color 0.25s ease;
}

/* Title */
.carddr-title {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
  color: #0f172a;
  margin: 0;
  flex: 1;
  transition: color 0.25s ease;
}

/* Read Here link */
.carddr-link {
  font-size: 13px;
  font-weight: 600;
  color: #2563eb;
  text-decoration: none;
  border-top: 1px solid rgba(203, 213, 225, 0.6);
  padding-top: 10px;
  width: 100%;
  display: inline-block;
  margin-top: auto;
  transition: color 0.25s ease, border-color 0.25s ease;
}

.carddr-link:hover {
  color: #1d4ed8;
}

@keyframes slide {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

















// for logo scroll
.logocard-slideerr-container {
  width: 100%;
  padding-top: 30px;
  padding-bottom: 50px;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  z-index: 2;
}
.logocardds-slider-track {
  display: flex;
  width: max-content;
  animation: logoslide 55s linear infinite;
  position: relative;
  z-index: 2;
}
.logocardds-slider-track:hover {
  animation-play-state: paused; 
}
@keyframes logoslide {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-50%);
  }
}



















/* FAQ Section Container */

.faq{
  width: 100%;
  height: 100%;
  background-color: rgb(255, 255, 255);
  /* height: 80vh; */
  padding-top: 90px;
  padding-bottom: 90px;
  display: flex;
  justify-content: center;
  align-items: center;

}

.faq-container {
  max-width: 1300px;
  display: flex;
  z-index: 2;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  /* margin: 50px auto; */
  text-align: center;
  font-family: "Arial", sans-serif;
}

.faq-title {
  font-size: 28px;
  font-weight: bold;
  color: #1e293b;
  margin: 0;
}

.faq-subtitle {
  font-size: 16px;
  color: #64748b;
  margin-bottom: 20px;
}

/* FAQ List */
.faq-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Individual FAQ Item */
.faq-item {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 15px;
  cursor: pointer;
  transition: background 0.3s;
}

.faq-item:hover {
  background: #f1f5f9;
}

/* FAQ Question */
.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}


/* FAQ Answer */
.faq-answer {
  padding-top: 10px;
  font-size: 14px;
  color: #64748b;
  text-align: left;
}

/* Expand/Collapse Icon */
.faq-icon {
  transition: transform 0.3s;
}

.faq-icon.open {
  transform: rotate(180deg);
}


.mmeessaaggee-btn{
  height: 65px;
  width: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: rgb(50, 92, 245);
  position: fixed;
  bottom: 20px;
  cursor: pointer;
  z-index: 10;
  right: 20px;
}

.mmee{
  font-size: 21px;
  color: white;
}




.four-iiccoonnss{
  z-index: 10;
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 0;
  gap: 10px;
  bottom: 25px;
}


.onee{
  /* background-color: red; */
  display: flex;
  position: relative;
  left: -100px;
  text-decoration: none;
  cursor: pointer;
  padding-right: 15px;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  justify-content: center;
  color: white;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 20px;
  padding-left: 8px;
  z-index: 1;

  gap: 23px;
  background: #367edb;
  align-items: center;
  flex-direction: row;
}

.onee a{
  text-decoration: none;
  cursor: pointer;
  color: white;
}

.twoo a{
  text-decoration: none;
  cursor: pointer;
  color: white;
}

.twoo{
  /* background-color: red; */
  display: flex;
  position: relative;
  left: -100px;
  font-size: 20px;

  padding-right: 5px;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  justify-content: center;
  color: white;
  padding-top: 5px;
  left: -100px;
  cursor: pointer;
  padding-bottom: 5px;
  padding-left: 8px;
  z-index: 1;

  gap: 25px;
  background: #367edb;
  align-items: center;
  flex-direction: row;
}
.three{
  /* background-color: red; */
  display: flex;
  left: -100px;
  cursor: pointer;
  position: relative;
  font-size: 20px;

  left: -100px;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  justify-content: center;
  color: white;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 8px;
  gap: 35px;
  z-index: 1;

  background: #367edb;
  flex-direction: row;
}
.fourr{
  /* background-color: red; */
  display: flex;
  left: -100px;
  cursor: pointer;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  justify-content: center;
  color: white;
  font-size: 20px;
  z-index: 1;
  position: relative;
  left: -100px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 8px;
  gap: 45px;
   background:#367edb;
  align-items: center;
  flex-direction: row;
}
.fourr:hover, 
.three:hover, 
.twoo:hover, 
.onee:hover {
    transform: translateX(100px); /* Moves right on hover */
    box-shadow: 0 4px 10px rgba(78, 84, 200, 0.5);
}
    
.caseee-study {
  position: relative;
  width: 100%;
  z-index: 2;
  min-height: 680px;
  overflow: hidden;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  color: #0f172a;
  padding: 92px 0 0;
  background: #f8fafc;
}

.caseee-study::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background:
    linear-gradient(90deg, rgba(248, 250, 252, 0.98) 0%, rgba(248, 250, 252, 0.92) 48%, rgba(224, 242, 254, 0.76) 100%),
    radial-gradient(circle at 82% 14%, rgba(14, 165, 233, 0.16), transparent 34%);
}

.caseee-study::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background-image:
    linear-gradient(rgba(15, 23, 42, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(15, 23, 42, 0.05) 1px, transparent 1px);
  background-size: 48px 48px;
  opacity: 0.5;
  pointer-events: none;
}

/* Background Video */
.background-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  opacity: 0.08;
  filter: grayscale(90%) contrast(1.08);
}

/* Content Styling */
.ccoontent {
  position: relative;
  z-index: 1;
  width: min(1180px, calc(100% - 40px));
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 400px;
  gap: 52px;
  align-items: center;
}

/* Left block — blue left border accent */
.ccase-left {
  border-left: 4px solid #2563eb;
  padding-left: 24px;
}

.caseee-study h1 {
  font-size: clamp(28px, 3.5vw, 50px);
  line-height: 1.15;
  font-weight: 800;
  margin: 0 0 20px;
  color: #0f172a;
  letter-spacing: -0.5px;
}

/* "Measurable Impact" blue highlight */
.highlight-blue {
  color: #2563eb;
}

.caseee-study p {
  margin-left: 0;
}

.caseee-study .ccoontent > div:first-child > p,
.ccase-left > p {
  max-width: 480px;
  font-size: 16px;
  line-height: 1.75;
  margin: 0 0 28px;
  color: #475569;
}

/* Metrics card */
.case-metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  padding: 28px 24px;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.1);
  backdrop-filter: blur(16px);
  align-items: stretch;
}

.case-metric {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 8px 24px;
  border-right: 2px solid rgba(37, 99, 235, 0.25);
  flex: 1;
  height: 100%;
}

.case-metric:first-child {
  padding-left: 8px;
}

.case-metric:last-child {
  border-right: none;
}

.metric-icon {
  display: none;
}

.case-metric strong {
  color: #2563eb;
  font-size: 36px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 12px;
  display: block;
}

.case-metric span {
  color: #374151;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
}

/* Buttons */
.buttons {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.caseee-study .btn {
  padding: 12px 20px;
  border: none;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  color: #fff;
  transition: 0.25s ease;
  background-color: rgba(14, 165, 233, 0.84);
  border-radius: 6px;
}

.caseee-study .primary {
  background: black;
  color: white;
}

.caseee-study .primary:hover {
  background: white;
  color: black;
}

.caseee-study .secondary {
  background: #0f172a;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 13px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.18);
  transition: all 0.25s ease;
}
  background: #0f172a;
  color: #fff;
  border: 1px solid #0f172a;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.14);
}

.caseee-study .secondary:hover {
  background: #38bdf8;
  border-color: #38bdf8;
  color: #082f49;
  transform: translateY(-2px);
}

.caseee-study .primaryey {
  background: #e0f2fe;
  color: #075985;
  border: 1px solid rgba(14, 165, 233, 0.28);
  padding: 9px 14px;
  font-size: 13px;
}

.caseee-study .primaryey:hover {
  background: #38bdf8;
  border-color: #38bdf8;
  color: #082f49;
}

@media (max-width: 900px) {
  .caseee-study {
    min-height: 0;
    padding-top: 72px;
  }

  .ccoontent {
    grid-template-columns: 1fr;
    gap: 28px;
    align-items: start;
  }

  .case-metrics {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 560px) {
  .caseee-study {
    padding-top: 56px;
  }

  .caseee-study h1 {
    font-size: 26px;
  }

  .ccase-left > p {
    font-size: 15px;
  }

  .case-metrics {
    grid-template-columns: repeat(3, 1fr);
  }

  .card-slideerr-container {
    mask-image: none;
    padding-bottom: 42px;
  }

  .carddr {
    width: 200px;
    min-height: 200px;
  }
}

.slidder{
  background-color: rgb(255, 255, 255);
  height: 35vh;
  width: 96%;
  margin: 10px;
}






/* contact us page */
/* Office Locations Styles */
.locations-container {
position: relative;
backdrop-filter: blur(6px);
z-index: 2;
  padding: 4rem 2rem;
  /* background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); */
}

.locations-title {
  text-align: center;
  color: #ffffff;
  margin: 0;
  margin-bottom: 20px;
  font-size: 2rem;
  font-weight: 700;
}

.locations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1600px;
  padding-bottom: 10px;
  margin: 0 auto;
}

.location-card {
  background: rgba(255, 255, 255, 0.422);
  backdrop-filter: blur(3px);
  border-radius: 12px;
  padding: 0.5rem;
  z-index: 2;
  gap: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.location-card:hover {
  transform: translateY(-5px);
}

.location-image {
  width: 100%;
  height: 200px;
  z-index: 2;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.location-name {
  font-size: 1.2rem;
  color: #393939;
  margin-bottom: 1rem;
  font-weight: 600;
}

.location-address {
  color: #ffffff;
  margin-bottom: 1rem;
  z-index: 2;
  font-size: 0.9rem;
  line-height: 1.5;
}

.location-contact {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #ffffff;
  font-size: 1rem;
  height: 35px;
  margin-bottom: 0.5rem;
}

.location-contact svg {
  color: #ffffff;
}

@media (max-width: 768px) {
  .locations-title {
    font-size: 2rem;
  }
  
  .locations-grid {
    grid-template-columns: 1fr;
  }
  
  .locations-container {
    padding: 2rem 1rem;
  }
}
















.cs-container {
  /* min-height: 100vh; */
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
  /* background: linear-gradient(135deg, #f0f4ff 0%, #e6e9ff 100%); */
}

.cs-scroll-container {
  overflow: hidden;
  margin: 0 auto;
  max-width: 100%;
}



.cs-cards-wrapper {
  display: flex;
  gap: 1.5rem;
  padding: 1rem 0.5rem;
  transition: transform 0.1s linear;
}

.cs-card {
  flex: 0 0 320px;
  background: rgba(255, 255, 255, 0.264);
  background-position: center;
  background-size: cover;
  border-radius: 0.75rem;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(6px);
  transition: transform 0.2s;
}
/* 
.cs-card:hover {
  transform: scale(1.05);
} */

.cs-card-content {
  padding: 1.5rem;
  overflow: hidden;
}

.cs-card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
}

.cs-card-description {
  color: #ffffff;
  margin-bottom: 1rem;
}

/* .cs-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #4f46e5;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background-color 0.2s;
} */

/* .cs-button:hover {
  background-color: #4338ca;
} */



// .auto-scroll-wrapper {
//   overflow: hidden;
//   width: 100%;
//   overflow-x: auto;
//   scroll-behavior: smooth;
//    scrollbar-width: none;       
//   -ms-overflow-style: none;     
// }

// .auto-scroll-track {
//   display: flex;
//   gap: 16px;
//   animation: scroll-left 8s linear infinite;
// }

// .auto-scroll-track:hover {
//   animation-play-state: paused; /* Pause animation on hover */
// }



// @keyframes scroll-left {
//   0% {
//     transform: translateX(0%);
//   }
//   100% {
//     transform: translateX(-190%);
//   }
// }

// .scroll-card {
//   min-width: 300px;
//   flex-shrink: 0;
//   background: #fff;
//   border-radius: 12px;
//   padding: 20px;
//   box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
// }










.auto-scroll-wrapper {
  overflow: hidden;
  position: relative;
  width: 100%;
}

.auto-scroll-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari */
}

.auto-scroll-track {
  display: flex;
  gap: 20px;
  width: max-content;
  animation: success-scroll 45s linear infinite;
}

.auto-scroll-track:hover {
  animation-play-state: paused;
}

@keyframes success-scroll {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

.scroll-card {
  /* Equal slide size */
  width: 300px;
  height: 240px;
  min-width: 300px;
  max-width: 300px;
  margin: 0;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  flex-shrink: 0;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}


.profile {
  display: flex;
  align-items: center;
  gap: 10px;
}

.profile-img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 50%;
}

.profile-name {
  font-size: 18px;
  font-weight: bold;
}

.profile-position {
  font-size: 14px;
  color: gray;
}

.testimonial {
  margin-top: 10px;
  font-style: italic;
  color: #555;
}










.auto-scrollll-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  // white-space: nowrap;
  scroll-behavior: smooth;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE */
  cursor: grab;
  position: relative;
}

.auto-scrollll-wrapper::-webkit-scrollbar {
  display: none;
}

.auto-scrollll-track {
  display: inline-flex;
  animation: infiniteScroll 100s linear infinite;
}

.auto-scrollll-wrapper:hover .auto-scrollll-track {
  animation-play-state: paused; /* Hover pe ruk jayega */
}

.team-member {
  flex: 0 0 auto;
  width: 250px;
  margin: 10px;
  background: #f0f0f0;
  border-radius: 10px;
  padding: 15px;
  text-align: center;
  box-sizing: border-box;
}

/* Infinite Scroll Animation */
@keyframes infiniteScroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-80%); /* Half track ka */
  }
}







.spservices {
  padding: 40px;
  position: relative;
  z-index: 2;
  font-family: Arial, sans-serif;
  background-color: #f9f9f9;
  text-align: center;
  overflow: hidden;
}

.spservices-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 10px;
}

.spservices-subtitle {
  font-size: 16px;
  color: #555;
  margin-bottom: 40px;
}

/* Wrapper for scrolling effect */
.spservices-scroller {
  overflow: hidden;
  position: relative;
}

/* Container that moves */


.spservices-cards {
  display: flex;
  gap: 30px;
  
  // overflow: hidden;
  // width: max-content;
  animation: scroll-left 75s linear infinite;
}

.spservices-cards:hover {
  animation-play-state: paused;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-80%);
  }
}

.spservice-card {
  width: 300px;
  border: 1px solid #ddd;
  border-radius: 12px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.spservice-card:hover {
  transform: translateY(-5px);
}

.spcard-header1 {
  height: 120px;
  background: url("/images/business-automation.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
  .spcard-header2 {
  height: 120px;
  background: url("/images/cloud-solutions.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
  .spcard-header3 {
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2020/06/08/05/39/problem-5273058_640.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
  .spcard-header4 {
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2020/03/26/22/29/server-4971994_1280.png");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
  .spcard-header5 {
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2016/11/23/14/45/coding-1853305_640.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
  .spcard-header13{
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2018/05/04/10/30/team-3373638_640.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
.spcard-header14{
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background:
    linear-gradient(rgba(15, 23, 42, 0.14), rgba(15, 23, 42, 0.28)),
    url("https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=900&q=80");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
.spcard-header15{
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2018/05/08/08/44/artificial-intelligence-3382507_640.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
.spcard-header16{
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background:
    linear-gradient(rgba(15, 23, 42, 0.12), rgba(15, 23, 42, 0.3)),
    url("https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=900&q=80");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
.spcard-header17{
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background:
    linear-gradient(rgba(15, 23, 42, 0.12), rgba(15, 23, 42, 0.28)),
    url("https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=900&q=80");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
.spcard-header18 {
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2017/07/31/11/21/people-2557396_640.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
.spcard-header19 {
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2024/03/13/19/06/ai-generated-8631634_640.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
  .spcard-header6 {
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2020/05/25/11/11/woman-5218160_640.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
  .spcard-header7 {
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2016/11/10/16/03/android-1814556_640.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
  .spcard-header8 {
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2015/06/10/16/36/mark-804938_640.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
  .spcard-header9 {
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2023/07/25/18/00/man-8149563_640.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
  .spcard-header10 {
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2020/11/24/09/56/women-5772029_640.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
  .spcard-header11 {
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2014/02/13/07/28/security-265130_640.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}
  .spcard-header12 {
  height: 120px;
  // background: linear-gradient(to bottom, #aaa, #eee);
  background: url("https://cdn.pixabay.com/photo/2022/03/22/11/38/injured-7084846_1280.png");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-transform: uppercase;
}

.spcard-content {
  padding: 20px;
  text-align: left;
}

.spcard-content h3 {
  font-size: 18px;
  margin-bottom: 10px;
}

.spcard-content p {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.spcard-content ul {
  padding-left: 0;
  list-style: none;
  margin-bottom: 20px;
}

.spcard-content li {
  margin-bottom: 6px;
  font-size: 14px;
  color: #333;
}

.spcard-content button {
  background: linear-gradient(to right, #4d9cfa, #5f66f5);
  border: none;
  padding: 10px 16px;
  color: white;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  width: 100%;
  transition: opacity 0.3s ease;
}

.spcard-content button:hover {
  opacity: 0.9;
}

.process-section {
  text-align: center;
  position: relative;
  z-index: 2;
    overflow: hidden;

  padding: 60px 20px;
  background-color: #f4f4f4;
  // max-width: 1200px;
  margin: auto;
}

.process-section h2 {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.subheading {
  font-size: 1.1rem;
  color: #555;
  max-width: 800px;
  margin: 0 auto 40px;
}





























.heapp {
  min-height: 20vh;
  position: relative;
  z-index: 2;
  overflow-x: hidden;
}

/* Locations section */
.helocations-section {
  padding: 10px 10px;
  position: relative;
  min-height: 30vh;
  overflow: hidden;
  max-width: 1600px;
  margin: 0 auto;
}

@media (min-width: 640px) {
  .helocations-section {
    padding: 10px 2rem;
  }
}

@media (min-width: 1024px) {
  .helocations-section {
    padding: 10px 3rem;
  }
}

/* Animated background */
.helocations-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: 
    radial-gradient(circle at 20% 90%, #4299e1 0%, transparent 45%),
    radial-gradient(circle at 80% 20%, #0ea5e9 0%, transparent 45%);
  opacity: 0.15;
  filter: blur(100px);
  animation: backgroundMove 20s linear infinite alternate;
  pointer-events: none;
}

@keyframes backgroundMove {
  0% { background-position: 0% 0%; }
  100% { background-position: 100% 100%; }
}

/* Header styles */
.heheader {
  text-align: center;
  // margin-bottom: 3rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
}

.heheader h2 {
  font-size: 2rem;
  // font-weight: 800;
  // margin-top: 10px;
  margin-bottom: 10px;
  // margin-bottom: 1rem;
  // background: linear-gradient(to right, #fff, #94a3b8);
  // -webkit-background-clip: text;
  // background-clip: text;
  color: white;
  text-shadow: 0 2px 10px rgba(255, 255, 255, 0.1);
}

@media (min-width: 640px) {
  .heheader h2 {
    font-size: 2.5rem;
  }
}

.heheader p {
  font-size: 1.125rem;
  color: rgba(255, 255, 255, 0.8);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.8;
}

/* Grid layout */
.helocations-grid {
  display: flex;
  justify-content: center;
  // grid-template-columns: repeat(1, 1fr);
  gap: 1.5rem;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

@media (min-width: 640px) {
  .helocations-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .helocations-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
}

/* Location card styles */
.helocation-card {
  position: relative;
  min-height: 300px;
  border-radius: 1.5rem;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
}

.helocation-card:hover {
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

@media (min-width: 1024px) {
  .helocation-card.expanded {
    grid-column: span 2;
    grid-row: span 2;
  }
}

/* Card background */
.hecard-background {
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.hecard-background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.hegradient-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, transparent 60%, rgba(0, 0, 0, 0.8));
  mix-blend-mode: multiply;
}

/* Card content */
.hecard-content {
  position: relative;
  z-index: 10;
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 2rem;
}

.helocation-header {
  display: flex;
  align-items: center;
  // margin-bottom: 0.75rem;
}

.heicon-wrapper {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(5px);
}

.heicon-wrapper svg {
  color: white;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.helocation-header h3 {
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.heregion {
  font-size: 1.125rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.headdress {
  margin-top: 1rem;
  overflow: hidden;
}

.headdress p {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  font-size: 1rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* Decorative elements */
.hedecorative-line {
  position: absolute;
  right: 1.5rem;
  top: 1.5rem;
  width: 0.5rem;
  border-radius: 9999px;
  transition: all 0.3s ease;
}




        `}</style>
      </div>

      <section className="stats-section" ref={sectionRef}>
        <div className="containerrr">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <React.Fragment key={stat.id}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  className="stat-card"
                >
                  <div className="stat-logo-wrap">
                    {stat.logoType === "google" ? (
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className="stat-logo">
                        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
                        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
                        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
                        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
                        <path fill="none" d="M0 0h48v48H0z" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className="stat-logo">
                        <rect width="48" height="48" rx="10" fill="#3b5bdb" />
                        <path d="M14 34V14h8c5.52 0 9 3.13 9 8 0 4.87-3.48 8-9 8h-3v4h-5zm5-8h3c2.48 0 4-1.4 4-4s-1.52-4-4-4h-3v8z" fill="#ffffff" />
                        <circle cx="36" cy="30" r="5" fill="#00bcd4" />
                      </svg>
                    )}
                  </div>
                  <div className="stat-stars">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className="stat-star">★</span>
                    ))}
                  </div>
                  <p className="stat-label">{stat.label}</p>
                  <div className="stat-label-divider" />
                  <p className="stat-sub">{stat.sub}</p>
                </motion.div>
                {index === 0 && <div className="stats-divider" />}
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      <div className="containerrrrrr">
        <h3 className="headinggg">Trusted by Industry Leaders</h3>
        <div className="logocard-slideerr-container">
          <div className="logocardds-slider-track">
            {clientLogos.concat(clientLogos).map((client, index) => (
              <motion.div
                key={`${client.id}-${index}`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.4 }}
                whileHover={{ scale: 1.05 }}
                className="logo-wrapperrr"
              >
                <img
                  src={client.logo || "/placeholder.svg"}
                  alt={client.name}
                  className="logo-imageee"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      <section className="success-section">
        <div className="contaiiiner">
          <h2 className="section-title">More Success Stories</h2>
          {/* Auto-scrolling wrapper */}
          <div className="auto-scroll-wrapper">
            <div className="auto-scroll-track">
              {clients.concat(clients).map((client, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  whileHover={{ y: -5, transition: { duration: 0.2 } }}
                  className="card scroll-card"
                >
                  <div className="card-header">
                    <div className="profile">
                      <img
                        src={client.image}
                        alt={client.name}
                        className="profile-img"
                      />
                      <div>
                        <h3 className="profile-name">{client.name}</h3>
                        <p className="profile-position">{client.position}</p>
                      </div>
                    </div>
                  </div>
                  <p className="testimonial">"{client.testimonial}"</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials-section">
        <div className="containerrrrr">
          {/* Section Header */}
          <div className="testimonial-section-header">
            <span className="testimonial-tag">✦ Client Stories</span>
            <h2 className="testimonial-heading">What Our Clients Say</h2>
            <p className="testimonial-subheading">
              Trusted by industry leaders and innovative businesses worldwide.
            </p>
          </div>

          <div
            className="testimonial-box"
            onMouseEnter={() => setAutoplay(false)}
            onMouseLeave={() => setAutoplay(true)}
          >
            

            {/* Top Bar with Counter and Nav Buttons */}
            <div className="testimonial-header">
              <div className="testimonial-counter">
                <span className="counter-current">
                  {activeTestimonial + 1 < 10
                    ? `0${activeTestimonial + 1}`
                    : activeTestimonial + 1}
                </span>
                <span className="counter-separator">/</span>
                <span className="counter-total">
                  {clients.length < 10 ? `0${clients.length}` : clients.length}
                </span>
              </div>

              <div className="testimonial-buttons">
                <button
                  onClick={prevTestimonial}
                  aria-label="Previous Testimonial"
                  className="testimonial-nav-btn"
                >
                  <ChevronLeft size={18} />
                </button>
                <button
                  onClick={nextTestimonial}
                  aria-label="Next Testimonial"
                  className="testimonial-nav-btn"
                >
                  <ChevronRight size={18} />
                </button>
              </div>
            </div>

            {/* Main Content */}
            <div className="testimonial-content">
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeTestimonial}
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -15 }}
                  transition={{ duration: 0.35, ease: "easeOut" }}
                  className="testimonial-card"
                >
                  <div className="client-info">
                    <div className="client-avatar-wrapper">
                      <img
                        src={
                          clients[activeTestimonial].image || "/placeholder.svg"
                        }
                        alt={clients[activeTestimonial].name}
                        className="client-image"
                      />
                      <span className="client-avatar-badge" title="Verified Partner">
                        <CheckCircle2 size={14} />
                      </span>
                    </div>

                    <h3 className="client-name">{clients[activeTestimonial].name}</h3>
                    <p className="client-position">{clients[activeTestimonial].position}</p>

                    <div className="rating">
                      {[...Array(5)].map((_, i) => (
                        <span
                          key={i}
                          className={
                            i < clients[activeTestimonial].rating
                              ? "star filled"
                              : "star"
                          }
                        >
                          ★
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="testimonial-text">
                    <p className="quote-text">
                      "{clients[activeTestimonial].testimonial}"
                    </p>

                    <div className="testimonial-tags">
                      {clients[activeTestimonial].company
                        .split(",")
                        .filter((tag) => tag.trim())
                        .map((tag, idx) => (
                          <span key={idx} className="tag-pill">
                            {tag.trim()}
                          </span>
                        ))}
                      <span className="verified-pill">
                        <CheckCircle2 size={13} />
                        Verified Client
                      </span>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>

            {/* Pagination Dots */}
            <div className="testimonial-dots">
              {clients.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveTestimonial(index)}
                  aria-label={`Go to testimonial ${index + 1}`}
                  className={index === activeTestimonial ? "dot active" : "dot"}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="caseee-study">
        {/* Background Video */}
        <video autoPlay loop muted className="background-video">
          <source
            src="https://cdn.pixabay.com/video/2015/10/16/1046-142621379_tiny.mp4"
            // src="https://cdn.pixabay.com/video/2015/10/16/1035-142621331_tiny.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>

        {/* Content */}
        <div className="ccoontent">
          <div className="ccase-left">
            <h1>
              Transforming Business Operations<br />
              With <span className="highlight-blue">Measurable Impact</span>
            </h1>
            <p>
              See how focused software,Marketing automation, and infrastructure work
              helped clients improve efficiency, reduce manual effort, and scale
              with greater confidence.
            </p>
            <div className="buttons">
              <a href="/appp">
                <button className="btn secondary">
                  View All Case Studies &nbsp;→
                </button>
              </a>
            </div>
          </div>

          <div className="case-metrics" aria-label="Case study highlights">
            <div className="case-metric">
              <strong>45%</strong>
              <span>Increase in operational efficiency</span>
            </div>
            <div className="case-metric">
              <strong>30%</strong>
              <span>Reduction in process costs</span>
            </div>
            <div className="case-metric">
              <strong>12+</strong>
              <span>Solution areas delivered</span>
            </div>
          </div>
        </div>

        <div className="card-slideerr-container">
          <div className="cardds-slider-track">
            {cards.concat(cards).map((card, index) => (
              <Link
                key={index}
                to={`/appp?study=${card.studyIndex}`}
                className={`carddr${card.highlighted ? " carddr--highlight" : ""}`}
                style={{ textDecoration: "none" }}
              >
                <div className="carddr-icon">
                  <span>{card.icon}</span>
                </div>
                <p className="carddr-label">{card.label}</p>
                <h3 className="carddr-title">{card.title}</h3>
                <span className="carddr-link">
                  Read Here &nbsp;→
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* .....................................................our service section.................................................. */}

      <div className="spservices">
        <h2 className="sectionnn-title" style={{ color: "black" }}>
          Our Services
        </h2>

        <p className="spservices-subtitle">
          We offer a wide range of IT solutions designed to help your business
          grow, innovate, and stay ahead of the competition.
        </p>

        <div className="scroll-wrapper">
          <div className="spservices-cards">
            <div className="spservice-card">
              <div className="spcard-header13"></div>
              <div className="spcard-content">

                <h3>Enterprise & Government Software Development</h3>
                <p>
                  We design and develop secure, scalable enterprise-grade and
                  government software systems tailored for compliance,
                  performance, and long-term digital transformation initiatives.
                </p>
                <ul>
                  <li>✔️ ERP & enterprise platforms</li>
                  <li>✔️ E-governance systems</li>
                  <li>✔️ Marketing automation</li>
                  <li>✔️ Regulatory-compliant systems</li>
                  <li>✔️ Large-scale digital infrastructure</li>
                </ul>
              </div>
            </div>
            <div className="spservice-card">
              <div className="spcard-header14"></div>
              <div className="spcard-content">
                <h3>Smart Security, Tracking & Digital Infrastructure</h3>
                <p>
                  Implement intelligent surveillance, tracking, and
                  infrastructure solutions that enhance safety, visibility, and
                  operational efficiency across industries.
                </p>
                <ul>
                  <li>✔️ Smart surveillance systems</li>
                  <li>✔️ GPS & asset tracking solutions</li>
                  <li>✔️ IoT-based monitoring</li>
                  <li>✔️ Infrastructure digitization</li>
                  <li>✔️ Command & control dashboards</li>
                </ul>
              </div>
            </div>
            <div className="spservice-card">
              <div className="spcard-header15"></div>
              <div className="spcard-content">
                <h3>AI-Powered Platforms & Marketing Automation</h3>
                <p>
                  Build next-generation AI platforms that automate processes,
                  enhance decision-making, and unlock powerful predictive
                  capabilities.
                </p>
                <ul>
                  <li>✔️ AI-driven business platforms</li>
                  <li>✔️ Robotic process automation (RPA)</li>
                  <li>✔️ Predictive analytics engines</li>
                  <li>✔️ Chatbots & virtual assistants</li>
                  <li>✔️ Marketing Automation</li>
                </ul>
              </div>
            </div>
            <div className="spservice-card">
              <div className="spcard-header16"></div>
              <div className="spcard-content">
                <h3>Cloud, DevOps & System Integration</h3>
                <p>
                  Modernize your IT ecosystem with seamless cloud architecture,
                  DevOps automation, and enterprise-grade system integrations.
                </p>
                <ul>
                  <li>✔️ Hybrid & multi-cloud solutions</li>
                  <li>✔️ DevOps automation pipelines</li>
                  <li>✔️ Microservices architecture</li>
                  <li>✔️ API & third-party integrations</li>
                  <li>✔️ Infrastructure modernization</li>
                </ul>
              </div>
            </div>
            <div className="spservice-card">
              <div className="spcard-header17"></div>
              <div className="spcard-content">
                <h3>IT Consulting, Managed Services & Dedicated Teams</h3>
                <p>
                  Accelerate your projects with expert IT consulting, full-scale
                  managed services, and highly skilled dedicated technology
                  teams.
                </p>
                <ul>
                  <li>✔️ Strategic IT consulting</li>
                  <li>✔️ Managed infrastructure services</li>
                  <li>✔️ Staff augmentation</li>
                  <li>✔️ Dedicated development teams</li>
                  <li>✔️ Long-term technology partnerships</li>
                </ul>
              </div>
            </div>
            <div className="spservice-card">
              <div className="spcard-header18"></div>
              <div className="spcard-content">
                <h3>Digital Transformation & Marketing Automation</h3>
                <p>
                  Transform traditional operations into fully digital ecosystems
                  with streamlined workflows, automation, and smart process
                  optimization.
                </p>
                <ul>
                  <li>✔️ End-to-end digital transformation</li>
                  <li>✔️ Business process automation</li>
                  <li>✔️ Paperless workflow systems</li>
                  <li>✔️ CRM & ERP automation</li>
                  <li>✔️ Operational efficiency optimization</li>
                </ul>
              </div>
            </div>
            <div className="spservice-card">
              <div className="spcard-header19"></div>
              <div className="spcard-content">
                <h3> AI/ML Solutions</h3>
                <p>
                  Leverage the power of artificial intelligence and machine
                  learning to transform your business with intelligent
                  automation, predictive analytics, and data-driven insights.
                </p>
                <ul>
                  <li>✔️ Custom AI model development</li>
                  <li>✔️ Machine learning implementation</li>
                  <li>✔️ Natural language processing</li>
                  <li>✔️ Computer vision solutions</li>
                  <li>✔️ Predictive analytics</li>
                </ul>
                {/* <button>Learn More</button> */}
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header2"></div>
              <div className="spcard-content">
                <h3> Cloud Solutions</h3>
                <p>
                  Migrate, optimize, and manage your cloud infrastructure with
                  our comprehensive cloud solutions designed for scalability,
                  security, and cost-efficiency.
                </p>
                <ul>
                  <li>✔️ Cloud migration strategies</li>
                  <li>✔️ Multi-cloud management</li>
                  <li>✔️ Cloud optimization</li>
                  <li>✔️ Serverless architecture</li>
                  <li>✔️ Cloud security implementation</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header3"></div>
              <div className="spcard-content">
                <h3> Data Solutions</h3>
                <p>
                  Unlock the value of your data with our end-to-end data
                  management, analytics, and visualization solutions that drive
                  informed decision-making.
                </p>
                <ul>
                  <li>✔️ Big data architecture</li>
                  <li>✔️ Data warehousing</li>
                  <li>✔️ Business intelligence</li>
                  <li>✔️ Data visualization</li>
                  <li>✔️ ETL pipeline development</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header4"></div>
              <div className="spcard-content">
                <h3> DevOps</h3>
                <p>
                  Streamline your development and operations with our DevOps
                  services that enhance collaboration, Marketing automation, and
                  continuous delivery pipelines. We help organizations implement
                  DevOps practices to accelerate software delivery, improve
                  quality, and increase operational efficiency.
                </p>
                <ul>
                  <li>✔️ CI/CD pipeline implementation</li>
                  <li>✔️ Infrastructure as Code</li>
                  <li>✔️ Containerization with Docker</li>
                  <li>✔️ Kubernetes orchestration</li>
                  <li>✔️ Automated testing frameworks</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header5"></div>
              <div className="spcard-content">
                <h3>Software Development</h3>
                <p>
                  Create custom software solutions tailored to your specific
                  business needs with our expert development team using
                  cutting-edge technologies. We follow agile methodologies to
                  deliver high-quality software that solves real business
                  problems and provides a competitive advantage.
                </p>
                <ul>
                  <li>✔️ Custom software development</li>
                  <li>✔️ Legacy system modernization</li>
                  <li>✔️ API development and integration</li>
                  <li>✔️ Enterprise application development</li>
                  <li>✔️ Quality assurance and testing</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header6"></div>
              <div className="spcard-content">
                <h3>Web App Development</h3>
                <p>
                  Build responsive, high-performance web applications that
                  deliver exceptional user experiences across all devices and
                  platforms. Our web development team creates modern, scalable,
                  and secure web applications that help businesses engage
                  customers and streamline operations.
                </p>
                <ul>
                  <li>✔️ Progressive Web Apps (PWAs)</li>
                  <li>✔️ Single Page Applications (SPAs)</li>
                  <li>✔️ E-commerce platforms</li>
                  <li>✔️ Content Management Systems</li>
                  <li>✔️ Custom web portals</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header7"></div>
              <div className="spcard-content">
                <h3>Android/iOS App Development</h3>
                <p>
                  Develop native and cross-platform mobile applications that
                  engage users and extend your digital presence to mobile
                  devices. Our mobile app development team creates intuitive,
                  feature-rich applications that provide seamless experiences
                  across iOS and Android platforms.
                </p>
                <ul>
                  <li>✔️ Native iOS development</li>
                  <li>✔️ Native Android development</li>
                  <li>✔️ Cross-platform development</li>
                  <li>✔️ Mobile app UI/UX design</li>
                  <li>✔️ App store optimization</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header8"></div>
              <div className="spcard-content">
                <h3>SaaS Services</h3>
                <p>
                  Deploy and manage Software-as-a-Service solutions that provide
                  flexibility, accessibility, and reduced maintenance overhead.
                  Our SaaS expertise helps businesses transition to
                  subscription-based models, improving scalability and reducing
                  total cost of ownership.
                </p>
                <ul>
                  <li>✔️ SaaS platform development</li>
                  <li>✔️ Multi-tenant architecture</li>
                  <li>✔️ Subscription management</li>
                  <li>✔️ SaaS integration services</li>
                  <li>✔️ SaaS migration strategies</li>
                </ul>
              </div>
            </div>

            {/* <div className="spservice-card">
            <div className="spcard-header9"></div>
            <div className="spcard-content">
              <h3>PaaS Services</h3>
              <p>
                Utilize our Platform-as-a-Service offerings to accelerate application development and deployment with pre-configured environments. Our PaaS solutions provide developers with the tools and infrastructure needed to build, test, and deploy applications quickly and efficiently.
              </p>
              <ul>
                <li>✔️ Custom PaaS implementation</li>
                <li>✔️ Development environment setup</li>
                <li>✔️ Deployment automation</li>
                <li>✔️ Scalable application platforms</li>
                <li>✔️ PaaS monitoring and management</li>
              </ul>
            </div>
          </div>

          <div className="spservice-card">
            <div className="spcard-header10"></div>
            <div className="spcard-content">
              <h3>IaaS Services</h3>
              <p>
                Scale your infrastructure on-demand with our Infrastructure-as-a-Service solutions providing virtualized computing resources. Our IaaS offerings give you the flexibility to provision and manage computing, storage, and networking resources as needed, without capital expenditure.
              </p>
              <ul>
                <li>✔️ Virtual machine provisioning</li>
                <li>✔️ Storage solutions</li>
                <li>✔️ Network infrastructure</li>
                <li>✔️ Load balancing</li>
                <li>✔️ Disaster recovery infrastructure</li>
              </ul>
            </div>
          </div> */}

            <div className="spservice-card">
              <div className="spcard-header11"></div>
              <div className="spcard-content">
                <h3>Cyber Security</h3>
                <p>
                  Protect your digital assets with our comprehensive security
                  services including threat detection, prevention, and incident
                  response. Our security experts help you identify
                  vulnerabilities, implement robust security controls, and
                  develop incident response plans to protect your business.
                </p>
                <ul>
                  <li>✔️ Security assessment and auditing</li>
                  <li>✔️ Penetration testing</li>
                  <li>✔️ Security monitoring</li>
                  <li>✔️ Compliance management</li>
                  <li>✔️ Security awareness training</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header12"></div>
              <div className="spcard-content">
                <h3>Disaster Recovery Solution</h3>
                <p>
                  Ensure business continuity with our robust disaster recovery
                  solutions designed to minimize downtime and data loss during
                  disruptions. We help you develop and implement comprehensive
                  disaster recovery plans that protect your critical systems and
                  data from unexpected events.
                </p>
                <ul>
                  <li>✔️ Business continuity planning</li>
                  <li>✔️ Backup and recovery solutions</li>
                  <li>✔️ High availability systems</li>
                  <li>✔️ Disaster recovery testing</li>
                  <li>✔️ Recovery time optimization</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header1"></div>
              <div className="spcard-content">

                <h3>Business Automation</h3>
                <p>
                  Automate repetitive business tasks and operational workflows
                  with reliable digital systems that reduce manual effort,
                  improve accuracy, and speed up everyday processes.
                </p>
                <ul>
                  <li>✔️ Workflow automation</li>
                  <li>✔️ Business process automation</li>
                  <li>✔️ Task scheduling systems</li>
                  <li>✔️ Report and email automation</li>
                  <li>✔️ System-to-system automation</li>
                </ul>
              </div>
            </div>


            <div className="spservice-card">
              <div className="spcard-header3"></div>
              <div className="spcard-content">
                <h3> Data Solutions</h3>
                <p>
                  Unlock the value of your data with our end-to-end data
                  management, analytics, and visualization solutions that drive
                  informed decision-making.
                </p>
                <ul>
                  <li>✔️ Big data architecture</li>
                  <li>✔️ Data warehousing</li>
                  <li>✔️ Business intelligence</li>
                  <li>✔️ Data visualization</li>
                  <li>✔️ ETL pipeline development</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header4"></div>
              <div className="spcard-content">
                <h3> DevOps</h3>
                <p>
                  Streamline your development and operations with our DevOps
                  services that enhance collaboration, automation, and
                  continuous delivery pipelines. We help organizations implement
                  DevOps practices to accelerate software delivery, improve
                  quality, and increase operational efficiency.
                </p>
                <ul>
                  <li>✔️ CI/CD pipeline implementation</li>
                  <li>✔️ Infrastructure as Code</li>
                  <li>✔️ Containerization with Docker</li>
                  <li>✔️ Kubernetes orchestration</li>
                  <li>✔️ Automated testing frameworks</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header5"></div>
              <div className="spcard-content">
                <h3>Software Development</h3>
                <p>
                  Create custom software solutions tailored to your specific
                  business needs with our expert development team using
                  cutting-edge technologies. We follow agile methodologies to
                  deliver high-quality software that solves real business
                  problems and provides a competitive advantage.
                </p>
                <ul>
                  <li>✔️ Custom software development</li>
                  <li>✔️ Legacy system modernization</li>
                  <li>✔️ API development and integration</li>
                  <li>✔️ Enterprise application development</li>
                  <li>✔️ Quality assurance and testing</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header6"></div>
              <div className="spcard-content">
                <h3>Web App Development</h3>
                <p>
                  Build responsive, high-performance web applications that
                  deliver exceptional user experiences across all devices and
                  platforms. Our web development team creates modern, scalable,
                  and secure web applications that help businesses engage
                  customers and streamline operations.
                </p>
                <ul>
                  <li>✔️ Progressive Web Apps (PWAs)</li>
                  <li>✔️ Single Page Applications (SPAs)</li>
                  <li>✔️ E-commerce platforms</li>
                  <li>✔️ Content Management Systems</li>
                  <li>✔️ Custom web portals</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header7"></div>
              <div className="spcard-content">
                <h3>Android/iOS App Development</h3>
                <p>
                  Develop native and cross-platform mobile applications that
                  engage users and extend your digital presence to mobile
                  devices. Our mobile app development team creates intuitive,
                  feature-rich applications that provide seamless experiences
                  across iOS and Android platforms.
                </p>
                <ul>
                  <li>✔️ Native iOS development</li>
                  <li>✔️ Native Android development</li>
                  <li>✔️ Cross-platform development</li>
                  <li>✔️ Mobile app UI/UX design</li>
                  <li>✔️ App store optimization</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header8"></div>
              <div className="spcard-content">
                <h3>SaaS Services</h3>
                <p>
                  Deploy and manage Software-as-a-Service solutions that provide
                  flexibility, accessibility, and reduced maintenance overhead.
                  Our SaaS expertise helps businesses transition to
                  subscription-based models, improving scalability and reducing
                  total cost of ownership.
                </p>
                <ul>
                  <li>✔️ SaaS platform development</li>
                  <li>✔️ Multi-tenant architecture</li>
                  <li>✔️ Subscription management</li>
                  <li>✔️ SaaS integration services</li>
                  <li>✔️ SaaS migration strategies</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header9"></div>
              <div className="spcard-content">
                <h3>PaaS Services</h3>
                <p>
                  Utilize our Platform-as-a-Service offerings to accelerate
                  application development and deployment with pre-configured
                  environments. Our PaaS solutions provide developers with the
                  tools and infrastructure needed to build, test, and deploy
                  applications quickly and efficiently.
                </p>
                <ul>
                  <li>✔️ Custom PaaS implementation</li>
                  <li>✔️ Development environment setup</li>
                  <li>✔️ Deployment automation</li>
                  <li>✔️ Scalable application platforms</li>
                  <li>✔️ PaaS monitoring and management</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header10"></div>
              <div className="spcard-content">
                <h3>IaaS Services</h3>
                <p>
                  Scale your infrastructure on-demand with our
                  Infrastructure-as-a-Service solutions providing virtualized
                  computing resources. Our IaaS offerings give you the
                  flexibility to provision and manage computing, storage, and
                  networking resources as needed, without capital expenditure.
                </p>
                <ul>
                  <li>✔️ Virtual machine provisioning</li>
                  <li>✔️ Storage solutions</li>
                  <li>✔️ Network infrastructure</li>
                  <li>✔️ Load balancing</li>
                  <li>✔️ Disaster recovery infrastructure</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header11"></div>
              <div className="spcard-content">
                <h3>Cyber Security</h3>
                <p>
                  Protect your digital assets with our comprehensive security
                  services including threat detection, prevention, and incident
                  response. Our security experts help you identify
                  vulnerabilities, implement robust security controls, and
                  develop incident response plans to protect your business.
                </p>
                <ul>
                  <li>✔️ Security assessment and auditing</li>
                  <li>✔️ Penetration testing</li>
                  <li>✔️ Security monitoring</li>
                  <li>✔️ Compliance management</li>
                  <li>✔️ Security awareness training</li>
                </ul>
              </div>
            </div>

            <div className="spservice-card">
              <div className="spcard-header12"></div>
              <div className="spcard-content">
                <h3>Disaster Recovery Solution</h3>
                <p>
                  Ensure business continuity with our robust disaster recovery
                  solutions designed to minimize downtime and data loss during
                  disruptions. We help you develop and implement comprehensive
                  disaster recovery plans that protect your critical systems and
                  data from unexpected events.
                </p>
                <ul>
                  <li>✔️ Business continuity planning</li>
                  <li>✔️ Backup and recovery solutions</li>
                  <li>✔️ High availability systems</li>
                  <li>✔️ Disaster recovery testing</li>
                  <li>✔️ Recovery time optimization</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <IndustriesSection />
      {/* ===== Why Work With Us ===== */}
      <section className="wwu-section">
        <div className="wwu-container">

          {/* Content Side */}
          <motion.div
            className="wwu-content"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="wwu-eyebrow">Join Our Team</span>
            <h2 className="wwu-title">Why Work With Us?</h2>
            <div className="wwu-divider" />
            <p className="wwu-desc">
              At ITSoftlab, our people are our greatest asset. We foster a culture
              of collaboration, continuous learning, and mutual respect — where
              every voice is heard, every idea is valued, and every success is
              celebrated together.
            </p>

            <div className="wwu-benefits-grid">
              {benefits.map((benefit, index) => (
                <motion.div
                  key={index}
                  className="wwu-benefit-item"
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.07 }}
                >
                  <span className="wwu-check">✓</span>
                  <span>{benefit}</span>
                </motion.div>
              ))}
            </div>

            <motion.a
              href="/careerpage"
              className="wwu-cta-btn"
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.97 }}
            >
              Explore Careers →
            </motion.a>
          </motion.div>

          {/* Image Side */}
          <motion.div
            className="wwu-image-wrap"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <img
              src="/images/life1.jpg"
              alt="Team at ITSoftlab"
              className="wwu-image"
            />
          </motion.div>

        </div>

        <style>{`
          .wwu-section {
            background: #f8fafc;
            padding: 0;
            position: relative;
            z-index: 2;
            overflow: hidden;
          }

          .wwu-container {
            max-width: 100%;
            margin: 0;
            display: grid;
            grid-template-columns: 50% 50%;
            gap: 0;
            align-items: stretch;
          }

          /* Image — fills entire left cell, no gaps */
          .wwu-image-wrap {
            position: relative;
            overflow: hidden;
            min-height: 500px;
            background: #f8fafc;
            padding: 28px;
          }

          .wwu-image {
            position: absolute;
            top: 50%;
            left: 50%;
            width: calc(100% - 56px);
            height: calc(100% - 56px);
            transform: translate(-50%, -50%);
            object-fit: cover;
            object-position: center center;
            display: block;
            border: 6px solid #ffffff;
            border-radius: 12px;
            box-shadow: 0 8px 32px rgba(0,0,0,0.18);
          }

          /* Content side */
          .wwu-content {
            padding: 70px 64px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            background: #f8fafc;
          }

          /* Content */
          .wwu-eyebrow {
            display: inline-block;
            background: #eff6ff;
            color: #2563eb;
            font-size: 12px;
            font-weight: 700;
            letter-spacing: 1.5px;
            text-transform: uppercase;
            padding: 6px 16px;
            border-radius: 20px;
            margin-bottom: 18px;
            width: fit-content;
          }

          .wwu-title {
            font-size: 36px;
            font-weight: 800;
            color: #0f172a;
            line-height: 1.2;
            margin: 0 0 14px;
          }

          .wwu-divider {
            width: 52px;
            height: 4px;
            background: linear-gradient(to right, #2563eb, #60a5fa);
            border-radius: 4px;
            margin-bottom: 22px;
          }

          .wwu-desc {
            font-size: 15.5px;
            color: #475569;
            line-height: 1.85;
            margin-bottom: 28px;
          }

          .wwu-benefits-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 13px 24px;
            margin-bottom: 36px;
          }

          .wwu-benefit-item {
            display: flex;
            align-items: flex-start;
            gap: 10px;
            font-size: 14.5px;
            color: #334155;
            font-weight: 500;
            line-height: 1.5;
          }

          .wwu-check {
            flex-shrink: 0;
            width: 20px;
            height: 20px;
            background: #eff6ff;
            color: #2563eb;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: 700;
            margin-top: 2px;
          }

          .wwu-cta-btn {
            display: inline-block;
            background: linear-gradient(135deg, #2563eb, #1e40af);
            color: white;
            padding: 13px 30px;
            border-radius: 50px;
            font-size: 15px;
            font-weight: 600;
            text-decoration: none;
            box-shadow: 0 6px 20px rgba(37,99,235,0.3);
            transition: box-shadow 0.3s ease, transform 0.2s ease;
            width: fit-content;
          }

          .wwu-cta-btn:hover {
            box-shadow: 0 12px 32px rgba(37,99,235,0.45);
            transform: translateY(-2px);
          }

          @media (max-width: 900px) {
            .wwu-container {
              grid-template-columns: 1fr;
            }
            .wwu-image-wrap {
              min-height: 280px;
            }
            .wwu-content {
              padding: 40px 24px;
            }
            .wwu-title {
              font-size: 26px;
            }
            .wwu-benefits-grid {
              grid-template-columns: 1fr;
            }
          }
        `}</style>
      </section>

      {/* if you want your employ page section so just open these comment */}
      {/* <section id="team" className="team-section">
        <div className="contaiiinner">
          <div className="headerrer">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <h2 className="title">Meet Our Team</h2>
              <p className="description">
                Our talented team of professionals is dedicated to delivering
                exceptional results for our clients.
              </p>
            </motion.div>
          </div>

          <div className="team-grid">
            <div
              className="auto-scrollll-wrapper"
              ref={scrollRef}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onMouseDown={handleMouseDown}
              onMouseLeaveCapture={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
            >
              <div className="auto-scrollll-track">
                {[...teamMembers, ...teamMembers, ...teamMembers, ...teamMembers].map((member, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="team-member"
                  >
                    <div className="image-container">
                      <img src={member.image || "/placeholder.svg"} alt={member.name} className="team-image" />
                      <div className="social-icons">
                        <a href={member.social.linkedin} className="icon linkedin">
                          <Linkedin size={18} />
                        </a>
                        <a href={member.social.twitter} className="icon twitter">
                          <Twitter size={18} />
                        </a>
                        <a href={`mailto:${member.social.email}`} className="icon email">
                          <Mail size={18} />
                        </a>
                      </div>
                    </div>
                    <h3 className="member-name">{member.name}</h3>
                    <p className="position">{member.position}</p>
                    <p className="bio">{member.bio}</p>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>












          <div
            style={{
              paddingBottom: "80px",
              zIndex: "2",
              background: "white",
              color: "black",
            }}
            className="footer text-center"
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <p
                className="footer-text"
                style={{ zIndex: "2", paddingBottom: "20px" }}
              >
                Want to join our team? We're always looking for talented
                individuals.
              </p>
              <a
                style={{
                  background: "rgba(0, 54, 251, 0.54)",
                  padding: "10px",
                  borderRadius: "8px",
                  color: "white",
                  textDecoration: "none",
                }}
                href="/companies"
                className="careers-button"
              >
                View Open Positions
              </a>
            </motion.div>
          </div>
        </div>
      </section> */}

      <p
        style={{
          color: "white",
          fontSize: "40px",
          textAlign: "center",
          paddingTop: "0",
          marginBottom: "0",
          fontWeight: "600",
        }}
      >
        Tech & Infrastructure Partners
      </p>
      <div className="slider-container">
        <div className="slider-track">
          {images.concat(images).map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Slide ${index + 1}`}
              className="slider-image"
            />
          ))}
        </div>
      </div>

      <div className="faq">
        <div className="faq-container">
          <h2 className="faq-title">Frequently Asked Questions</h2>
          <p className="faq-subtitle">
            Find answers to common questions about our services, process, and
            how we can help your business.
          </p>

          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="faq-item"
                onClick={() => toggleFAQ(index)}
              >
                <div className="faq-question">
                  {faq.question}
                  <span
                    className={`faq-icon ${openIndex === index ? "open" : ""}`}
                  >
                    &#9662;
                  </span>
                </div>
                {openIndex === index && (
                  <div className="faq-answer">{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* .....................................................contact us section.................................................. */}

      {/* <section className="locations-container">
        <h2 className="locations-title">Our Office Locations</h2>
        <div className="locations-grid">
          {offices.map((office) => (
            <div key={office.id} className="location-card">
              <img
                src={office.image}
                alt={office.name}
                className="location-image"
              />
              <h3 className="location-name">{office.name}</h3>
              <div className="location-contact">
                <MapPin size={18} />
                <p className="location-address">{office.address}</p>
              </div>

            </div>
          ))}
        </div>
      </section> */}

      <div className="heapp">
        <motion.section
          className="helocations-section"
          initial={{ opacity: 0 }}
          animate={{ opacity: visible ? 1 : 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.div
            className="heheader"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2>Our Office Locations</h2>
            {/* <p>With offices strategically located around the world, we provide exceptional service and support wherever you are.</p> */}
          </motion.div>

          <div className="helocations-grid">
            {officeLocations.map((location, index) => (
              <motion.div
                key={location.id}
                className={`helocation-card ${expandedId === location.id ? "expanded" : ""}`}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  delay: index * 0.1,
                  type: "spring",
                  stiffness: 100,
                }}
                whileHover={{ scale: 1.02 }}
                onClick={() =>
                  setExpandedId(expandedId === location.id ? null : location.id)
                }
              >
                <motion.div
                  className="hecard-background"
                  animate={{
                    scale: [1, 1.4, 1],
                    x: [0, 5, -5, 0],
                    y: [0, -5, 5, 0],
                  }}
                  transition={{
                    duration: 20,
                    repeat: Infinity,
                    repeatType: "reverse",
                    ease: "linear",
                  }}
                >
                  <img src={location.imageUrl} alt={location.city} />
                  <div
                    className="hegradient-overlay"
                    style={{
                      background: `linear-gradient(to bottom, transparent 60%, ${location.color}90, ${location.color}ee)`,
                    }}
                  />
                </motion.div>

                <div className="hecard-content">
                  <motion.div
                    className="helocation-header"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: 0.2 }}
                  >
                    <div
                      className="heicon-wrapper"
                      style={{ backgroundColor: location.color }}
                    >
                      <MapPin size={20} />
                    </div>
                    <h3>{location.city}</h3>
                  </motion.div>

                  <motion.p
                    className="heregion"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.3, delay: 0.3 }}
                  >
                    {location.region}
                  </motion.p>

                  <motion.div
                    className="headdress"
                    initial={{ height: 0 }}
                    animate={{
                      height: expandedId === location.id ? "auto" : 0,
                    }}
                    transition={{ duration: 0.3 }}
                  >
                    <p>{location.address}</p>
                  </motion.div>
                </div>

                <motion.div
                  className="hedecorative-line"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{
                    opacity: expandedId === location.id ? 1 : 0.6,
                    height: expandedId === location.id ? "64px" : "32px",
                  }}
                  style={{
                    backgroundColor: location.color,
                    boxShadow: `0 0 15px ${location.color}80`,
                  }}
                  transition={{ duration: 0.4 }}
                />
              </motion.div>
            ))}
          </div>
        </motion.section>
      </div>

      {/* ===== Footer ===== */}
      <footer className="footer">
        <div className="footer-container">

          {/* Brand */}
          <div className="footer-section footer-brand">
            <div className="footer-logo-wrap">
              <div className="footer-logo-img"></div>
            </div>
            <p>
              Empowering businesses with end-to-end 360° IT solutions,
              innovative digital products, and reliable technology services.
              We help organizations streamline operations, accelerate growth,
              and achieve digital transformation through cutting-edge software,
              web, mobile, cloud, and AI-driven solutions.
            </p>
            <p>
              Protect your data with top-notch cybersecurity measures. Awarded
              Best IT Company for consulting services and web development.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/aboutPage">About Us</a></li>
              <li><a href="/servicespage">Services</a></li>
              <li><a href="/careerpage">Careers</a></li>
              <li><a href="/contactus">Contact Us</a></li>
              <li><a href="/privacypage">Privacy Policy</a></li>
              <li><a href="/termpage">Terms &amp; Conditions</a></li>
              <li><a href="/products">Products</a></li>
            </ul>
          </div>

          {/* Our Services */}
          <div className="footer-section">
            <h4>Our Services</h4>
            <ul>
              <li><a href="/servicespage">Android / iOS App Development</a></li>
              <li><a href="/servicespage">Web App Development</a></li>
              <li><a href="/servicespage">Software Development</a></li>
              <li><a href="/servicespage">Cloud &amp; SaaS / PaaS / IaaS</a></li>
              <li><a href="/servicespage">Cyber Security</a></li>
              <li><a href="/servicespage">Disaster Recovery</a></li>
              <li><a href="/servicespage">AI / ML Solutions</a></li>
              <li><a href="/servicespage">DevOps &amp; Automation</a></li>
            </ul>
          </div>

          {/* Our Products */}
          <div className="footer-section">
            <h4>Our Products</h4>
            <ul>
              <li><a href="/crm">CRM</a></li>
              <li><a href="https://hrmsm.com/home">HRMS</a></li>
              <li><a href="/contactus">VMS</a></li>
              <li><a href="/contactus">ERP</a></li>
              <li><a href="/contactus">DMS</a></li>
              <li><a href="/contactus">LMS</a></li>
              <li><a href="/contactus">POS</a></li>
              <li><a href="/contactus">Marketing Automation</a></li>
            </ul>
          </div>

        </div>

        {/* Contact Bar */}
        <div className="footer-contact-bar">
          <div className="footer-contact-list">
            <div className="footer-contact-row">
              <strong>📞 Contact No</strong>
              <span>+91 7898822644</span>
            </div>
            <div className="footer-contact-row">
              <strong>☎ Landline</strong>
              <span>07314611999</span>
            </div>
            <div className="footer-contact-row">
              <strong>✉ Email</strong>
              <span>contact@itsoftlab.com</span>
            </div>
          </div>
        </div>

        <hr className="footer-hr" />
        <p className="footer-bottom">© 2026 IT SOFTLAB. All rights reserved.</p>
      </footer>


      {/* <div className="mmeessaaggee-btn">
        <a href="/" className="mmee">
          <i class="fa-solid fa-headset"></i>
        </a>
      </div> */}
    </>
  );
}

export default HomePage;
